import {
  Calc,
  CalcIndividualConfig,
  Coefficents,
  ConfigMap,
  Events,
  ResultsMonitor,
  GlobalSettingsData,
  IndividualConfig,
  KviShoppingCart,
  PackageCalc,
  PackageKviRecommends,
  PackageParamsInDetailReport,
  PackagePromo,
  PackagePromoRecommends,
  PreCalc,
  Promo,
  PromoIndividualConfig,
  PromoServerIndividualConfig,
  PromoType,
  Sales,
  Promotions,
  Results,
  Revaluation,
  RevaluationCalculateParams,
  RoundingRules,
  ScenarioAnalysisParams,
  ScenarioCodeOKRB,
  SelectBox,
  SkuRotationPeriodType,
  StrategyOfPriceOpt,
  SaleIndividualConfig,
  SaleServerIndividualConfig, TradingSettingsData,
    PromotionIndividualConfig, PromotionsServerIndividualConfig,
} from '@/interfaces/global-data';
import {
  CalcFilters,
  CalcIndividualConfigMap,
  CategoryOfSuppliers,
  categoryOfSuppliersSb,
  CategoryStrategies,
  categoryStrategiesSet,
  CompetitorsPriceMethods,
  competitorsPriceMethodsSb,
  CompetitorsPriceStrategies,
  competitorsPriceStrategiesSb,
  competitorsPromoPriceMethodsSb,
  competitorsPromoPriceStrategiesSb,
  eventChangingTypeType,
  eventPeriodicityType,
  eventTypeLoadType,
  IError,
  KviCartChangePrices,
  kviCartChangePricesSb,
  KviCartFilters,
  KviSearchMethod,
  KviStrategies,
  kviStrategiesSet,
  LoadEventChangingType,
  LoadEventPeriods,
  LoadEventType,
  NewProductPriceStrategy,
  newProductPriceStrategySb,
  PercentileTypes,
  percentileTypesSb,
  PromoFilters,
  SalesFilters,
  ModuleItemFilters,
  PromoIndividualConfigMap,
  ScenarioAnalysisFilters,
  UserRole,
  userRoleSb,
  SaleIndividualConfigMap, RevaluationExportFileFormat,
    PromotionIndividualConfigMap,
    AdditionalRole,
} from '@/interfaces/server-data';
import _ from 'lodash';
import {Component, Vue} from 'vue-property-decorator';
import moment from "moment";
import { TModuleType } from "@/pages/ModuleItems/data";
import { i18n } from '@/services/i18n';

const globalComponent = new Vue({
  data: {
    $calc: {},
    $results: {},
    $preCalc: {},
    $setupMasterCalc: {},
    $roundingRules: {},
    $scenario: {},
    $promo: {},
    $sales: {},
    $promotions: {},
    $packageCalc: {},
    $revaluation: {},
    $events: {},
    $resultsMonitor: {},
    $packageKviRecommends: {},
    $packagePromo: {},
    $packagePromoRecommends: {},
    $packageParamsInDetailReport: {},
    $kviCart: {},
    $scheduleCalc: {},
    $userRole: UserRole.ROLE_USER,
    $disallowedModules: [],
    $accessToSystemParams: false,
    $permissions: [],
    $additionalRoles: [] as AdditionalRole[],
  },
});

@Component
export default class LocalData extends Vue {

  get $calc(): Calc {
    return globalComponent.$data.$calc;
  }

  set $calc(calc: Calc) {
    globalComponent.$data.$calc = calc;
  }

  get $results(): Results {
    return globalComponent.$data.$results;
  }

  set $results(results: Results) {
    globalComponent.$data.$results = results;
  }

  get $roundingRules(): RoundingRules {
    return globalComponent.$data.$roundingRules
  }

  set $roundingRules(roundingRules: RoundingRules) {
    globalComponent.$data.$roundingRules = roundingRules
  }

  get $preCalc(): PreCalc {
    return globalComponent.$data.$preCalc;
  }

  set $preCalc(preCalc: PreCalc) {
    globalComponent.$data.$preCalc = preCalc;
  }

  get $setupMasterCalc(): Calc {
    return globalComponent.$data.$setupMasterCalc;
  }

  set $setupMasterCalc(setupMasterCalc: Calc) {
    globalComponent.$data.$setupMasterCalc = setupMasterCalc;
  }

  get $promo(): Promo {
    return globalComponent.$data.$promo;
  }

  set $promo(promo: Promo) {
    globalComponent.$data.$promo = promo;
  }

  get $sales(): Sales {
    return globalComponent.$data.$sales;
  }

  set $sales(sales: Sales) {
    globalComponent.$data.$sales = sales;
  }

  get $promotions(): Promotions {
    return globalComponent.$data.$promotions;
  }

  set $promotions(promotions: Promotions) {
    globalComponent.$data.$promotions = promotions;
  }

  get $revaluation(): Revaluation {
    return globalComponent.$data.$revaluation;
  }

  set $revaluation(revaluation: Revaluation) {
    globalComponent.$data.$revaluation = revaluation;
  }

  get $packageCalc(): PackageCalc {
    return globalComponent.$data.$packageCalc
  }


  set $packageCalc(packageCalc: PackageCalc) {
    globalComponent.$data.$packageCalc = packageCalc
  }

  get $events(): Events {
    return globalComponent.$data.$events
  }

  set $events(events: Events) {
    globalComponent.$data.$events = events
  }

  get $resultsMonitor(): ResultsMonitor {
    return globalComponent.$data.$resultsMonitor;
  }

  set $resultsMonitor(resultsMonitor: ResultsMonitor) {
    globalComponent.$data.$resultsMonitor = resultsMonitor;
  }

  get $packagePromo(): PackageCalc {
    return globalComponent.$data.$packagePromo
  }

  set $packagePromo($packagePromo: PackageCalc) {
    globalComponent.$data.$packagePromo = $packagePromo
  }

  get $scheduleCalc(): PackageCalc {
    return globalComponent.$data.$scheduleCalc
  }

  set $scheduleCalc(packageCalc: PackageCalc) {
    globalComponent.$data.$scheduleCalc = packageCalc
  }

  get $packagePromoRecommends(): PackagePromoRecommends {
    return globalComponent.$data.$packagePromoRecommends
  }

  set $packagePromoRecommends(packagePromoRecommends: PackagePromoRecommends) {
    globalComponent.$data.$packagePromoRecommends = packagePromoRecommends
  }

  get $kviCart(): KviShoppingCart {
    return globalComponent.$data.$kviCart
  }

  set $kviCart(kviCart: KviShoppingCart) {
    globalComponent.$data.$kviCart = kviCart
  }

  get $userRole(): UserRole {
    return globalComponent.$data.$userRole;
  }

  set $userRole(role: UserRole) {
    globalComponent.$data.$userRole = role;
  }

  get $accessToSystemParams(): boolean {
    return globalComponent.$data.$accessToSystemParams;
  }

  set $accessToSystemParams(accessToSystemParams: boolean) {
    globalComponent.$data.$accessToSystemParams = accessToSystemParams;
  }

  get $permissions(): string[] {
    return globalComponent.$data.$permissions;
  }

  set $permissions(permissions: string[]) {
    globalComponent.$data.$permissions = permissions;
  }

  get $additionalRoles(): AdditionalRole[] {
    return globalComponent.$data.$additionalRoles;
  }

  set $additionalRoles(additionalRoles: AdditionalRole[]) {
    globalComponent.$data.$additionalRoles = additionalRoles;
  }

  canSubmitRevaluationForApproval(): boolean {
    return this.$userId === 1
        || (!!this.$permissions && this.$permissions.includes('SUBMIT_REVALUATION_FOR_APPROVAL'));
  }

  get $userId(): number {
    return globalComponent.$data.$userId;
  }

  set $userId(userId: number) {
    globalComponent.$data.$userId = userId;
  }

  get $disallowedModules(): string[] {
    return globalComponent.$data.$disallowedModules;
  }

  get $packageKviRecommends(): PackageKviRecommends {
    return globalComponent.$data.$packageKviRecommends
  }

  set $packageKviRecommends(packageKviRecommends: PackageKviRecommends) {
    globalComponent.$data.$packageKviRecommends = packageKviRecommends
  }

  get $packageParamsInDetailReport(): PackageParamsInDetailReport {
    return globalComponent.$data.$packageParamsInDetailReport
  }

  set $packageParamsInDetailReport(packageParamsInDetailReport: PackageParamsInDetailReport) {
    globalComponent.$data.$packageParamsInDetailReport = packageParamsInDetailReport
  }

  get $scenario(): ScenarioAnalysisParams {
    return globalComponent.$data.$scenario;
  }

  set $scenario(scenario: ScenarioAnalysisParams) {
    globalComponent.$data.$scenario = scenario;
  }

  static compareTwoArrays(a: any[], b: any[]): boolean {
    if (a.length !== b.length) {
      return false
    }
    const _a = [...a].sort();
    const _b = [...b].sort();
    const notEqualsIndex = _a.findIndex((v, i) => v !== _b[i]);
    return notEqualsIndex === -1;
  }

  static filterNumberArrays(inArray: Array<number | null> | null, returnNull: boolean = false): number[] | null {
    if (inArray == null) {
      return returnNull ? null : [];
    }
    // -2 - это опция "не выбрано" в фильтрах в "Отчеты"
    const filtered: number[] = inArray.filter((i) => (i != null && i > 0) || (i === -2)) as number[];
    if (filtered.length === 0) {
      return returnNull ? null : [];
    }
    return filtered;
  }

  static zeroToNull(value: number | null): number | null {
    if (value == null) {
      return value;
    }
    // -2 - это опция "не выбрано" в фильтрах в "Отчеты"
    if (value <= 0 && value !== -2) {
      return null;
    }
    return value;
  }

  currentVersion: number = 91;

  saveCalc: any;
  saveResults: any;
  savePreCalc: any;
  saveSetupMasterCalc: any;
  savePromo: any;
  saveSales: any;
  savePromotions: any;
  saveRevaluation: any;
  savePackageCalc: any;
  saveEvents: any;
  saveResultsMonitor: any;
  savePackagePromo: any;
  savePackagePromoRecommends: any;
  saveKviShoppingCart: any;
  savePackageKviRecommends: any;
  savePackageParamsInDetailReport: any;
  saveScenarioAnalysis: any;
  savePackageSchedule: any;
  saveRoundingRules: any;

  competitorsPriceMethodsOpts = [competitorsPriceMethodsSb.MAX_PRICE, competitorsPriceMethodsSb.MEDIAN_PRICES, competitorsPriceMethodsSb.MIN_PRICE, competitorsPriceMethodsSb.AVG_PRICE, competitorsPriceMethodsSb.WESTENDORP];
  competitorsPromoPriceMethodsOpts = [competitorsPromoPriceMethodsSb.MAX_PRICE, competitorsPromoPriceMethodsSb.MEDIAN_PRICES, competitorsPromoPriceMethodsSb.MIN_PRICE, competitorsPromoPriceMethodsSb.AVG_PRICE, competitorsPromoPriceMethodsSb.WESTENDORP];
  kviCartChangePricesOpts = [kviCartChangePricesSb.ALL_CART_PRICES, kviCartChangePricesSb.CORRELATION_PRICES, kviCartChangePricesSb.ALL_PRICES];
  newProductPriceStrategyOpts = [newProductPriceStrategySb.PENETRATION_STRATEGY, newProductPriceStrategySb.SKIMMING_STRATEGY, newProductPriceStrategySb.MINIMUM_PROFITABILITY];
  categoryOfSuppliersOpts = [categoryOfSuppliersSb.ALL_SUPPLIERS, categoryOfSuppliersSb.ONLINE_SUPPLIERS];
  userRolesOpts = [userRoleSb.ROLE_USER, userRoleSb.ROLE_ADMIN];
  competitorsPriceStrategiesOpts = [competitorsPriceStrategiesSb.GREATER_THAN, competitorsPriceStrategiesSb.LESS_THAN, competitorsPriceStrategiesSb.EQUALS, competitorsPriceStrategiesSb.GREATER_THAN_BUT_BORDER];
  competitorsPromoPriceStrategiesOpts = [competitorsPromoPriceStrategiesSb.GREATER_THAN, competitorsPromoPriceStrategiesSb.LESS_THAN, competitorsPromoPriceStrategiesSb.EQUALS, competitorsPromoPriceStrategiesSb.GREATER_THAN_BUT_BORDER];
  kviStrategiesOpts = [{
    value: null,
    label: i18n.t('selectOptions.common.notSelected') as string,
  }, kviStrategiesSet.GREATER_THAN, kviStrategiesSet.LESS_THAN, kviStrategiesSet.EQUALS, kviStrategiesSet.GREATER_THAN_BUT_BORDER];

  categoryStrategyOpts = [categoryStrategiesSet.EMPTY, categoryStrategiesSet.REVENUE_GENERATOR, categoryStrategiesSet.INCOME_GENERATOR, categoryStrategiesSet.TRAFFIC_GENERATOR, categoryStrategiesSet.HYBRID, categoryStrategiesSet.DIFFERENTIAL];

  periodOptions: Array<SelectBox<number>> = [
    {value: 1, label: i18n.t('selectOptions.periods.day') as string},
    {value: 30, label: i18n.t('selectOptions.periods.month') as string},
    {value: 7, label: i18n.t('selectOptions.periods.week') as string},
  ];

  periodicityEventOptions: Array<SelectBox<LoadEventPeriods>> = [
    {value: LoadEventPeriods.DAY, label: i18n.t('selectOptions.periods.day') as string},
    {value: LoadEventPeriods.MONTH, label: i18n.t('selectOptions.periods.month') as string},
    {value: LoadEventPeriods.WEEK, label: i18n.t('selectOptions.periods.week') as string},
  ];

  changingTypeOptions: Array<SelectBox<LoadEventChangingType>> = [
    {value: LoadEventChangingType.DECREASE, label: i18n.t('selectOptions.changingType.decrease') as string},
    {value: LoadEventChangingType.INCREASE, label: i18n.t('selectOptions.changingType.increase') as string},
    {value: LoadEventChangingType.BOTH, label: i18n.t('selectOptions.changingType.both') as string},
  ];

  percentileOptions: Array<SelectBox<PercentileTypes>> = [
    {value: PercentileTypes.Q1, label: '0-25'},
    {value: PercentileTypes.Q2, label: '25-50'},
    {value: PercentileTypes.Q3, label: '50-75'},
    {value: PercentileTypes.Q4, label: '75-100'},
    {value: PercentileTypes.Q5, label: '0-100'},
  ];

  percentileTypeOpts = [
      percentileTypesSb.Q1,
      percentileTypesSb.Q2,
      percentileTypesSb.Q3,
      percentileTypesSb.Q4,
      percentileTypesSb.Q5
  ];

  coefficentList: Array<SelectBox<Coefficents>> = [
    {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: i18n.t('selectOptions.priceOptStrategy.maxGrossMargin') as string},
    {value: {k1: 0, k2: 1, enum: StrategyOfPriceOpt.maxRevenue}, label: i18n.t('selectOptions.priceOptStrategy.maxRevenue') as string},
    {value: {k1: 0.5, k2: 0.5, enum: StrategyOfPriceOpt.balanced}, label: i18n.t('selectOptions.priceOptStrategy.balanced') as string},
    {value: {k1: 0, k2: 0, enum: StrategyOfPriceOpt.baseChannel}, label: i18n.t('selectOptions.priceOptStrategy.baseChannel') as string},
  ];

  codeOKRBScenariosList: Array<SelectBox<ScenarioCodeOKRB>> = [
    {value: {name: 'AVERAGE'}, label: i18n.t('selectOptions.codeOKRBScenarios.byWeightedAvg') as string},
    {value: {name: 'KVI'}, label: i18n.t('selectOptions.codeOKRBScenarios.byKVI') as string},
    {value: {name: 'COMPETITIVE'}, label: i18n.t('selectOptions.codeOKRBScenarios.byCompetitive') as string},
    {value: {name: 'MAX_PRICE'}, label: i18n.t('selectOptions.codeOKRBScenarios.byMaxPrice') as string},
  ];

  seasonList: Array<SelectBox<number>> = [
    {value: 0, label: i18n.t('selectOptions.seasons.all') as string},
    {value: 2, label: i18n.t('selectOptions.seasons.spring') as string},
    {value: 1, label: i18n.t('selectOptions.seasons.winter') as string},
    {value: 3, label: i18n.t('selectOptions.seasons.summer') as string},
    {value: 4, label: i18n.t('selectOptions.seasons.autumn') as string},
  ];

  promoTypes: Array<SelectBox<PromoType>> = [
    {value: PromoType.DISCOUNT, label: i18n.t('selectOptions.promoTypes.discount') as string},
    {value: PromoType.PRICE, label: i18n.t('selectOptions.promoTypes.price') as string},
  ];

  rotationPeriodTypes: Array<SelectBox<SkuRotationPeriodType>> = [
      {value: SkuRotationPeriodType.MONTH, label: i18n.t('selectOptions.periods.month') as string},
      {value: SkuRotationPeriodType.TWO_WEEKS, label: i18n.t('selectOptions.periods.twoWeeks') as string},
      {value: SkuRotationPeriodType.QUARTER, label: i18n.t('selectOptions.periods.quarter') as string},
  ];

  created() {
    const versionStr = localStorage.getItem('version');
    let version = -1;
    if (versionStr != null) {
      version = parseInt(versionStr, 10);
    }
    if (version !== this.currentVersion) {
      localStorage.clear();
    }
    localStorage.setItem('version', this.currentVersion.toString());
    const self = this;
    this.saveCalc = _.debounce((newCalc: Calc, oldCalc: Calc) => {
      localStorage.setItem('isSaveStateAvailable', 'true')
      localStorage.setItem('calc', JSON.stringify(self.$calc));
    }, 250);

    this.saveResults = _.debounce((newResults: Results, oldResults: Results) => {
      localStorage.setItem('results', JSON.stringify(self.$results));
    }, 250);

    this.saveRoundingRules = _.debounce((newCalc: RoundingRules, oldCalc: RoundingRules) => {
      localStorage.setItem('roundingRules', JSON.stringify(self.$roundingRules));
    }, 250);

    this.savePreCalc = _.debounce((newCalc: PreCalc, oldCalc: PreCalc) => {
      localStorage.setItem('preCalc', JSON.stringify(self.$preCalc));
    }, 250);

    this.saveSetupMasterCalc = _.debounce((newCalc: Calc, oldCalc: Calc) => {
      localStorage.setItem('setupMasterCalc', JSON.stringify(self.$setupMasterCalc));
    }, 250);

    this.savePromo = _.debounce((newPromo: Promo, oldPromo: Promo) => {
      localStorage.setItem('promo', JSON.stringify(self.$promo));
    }, 250);

    // sales
    this.saveSales = _.debounce(() => {
      localStorage.setItem('sales', JSON.stringify(self.$sales));
    }, 250);

    // promotions
    this.savePromotions = _.debounce(() => {
      localStorage.setItem('promotions', JSON.stringify(self.$promotions));
    }, 250);

    this.saveRevaluation = _.debounce((newRevaluation: Revaluation, oldRevaluation: Revaluation) => {
      localStorage.setItem('revaluation', JSON.stringify(self.$revaluation));
    }, 250);

    this.savePackageCalc = _.debounce((newConf: PackageCalc, oldConf: PackageCalc) => {
      localStorage.setItem('packageCalc', JSON.stringify(self.$packageCalc));
    }, 250);

    this.savePackagePromo = _.debounce((newConf: PackagePromo, oldConf: PackagePromo) => {
      localStorage.setItem('packagePromo', JSON.stringify(self.$packagePromo));
    }, 250);

    this.savePackageSchedule = _.debounce((newConf: PackageCalc, oldConf: PackageCalc) => {
      localStorage.setItem('scheduleCalc', JSON.stringify(self.$scheduleCalc));
    }, 250);
    this.savePackagePromoRecommends = _.debounce((newConf: PackagePromoRecommends, oldConf: PackagePromoRecommends) => {
      localStorage.setItem('packagePromoRecommends', JSON.stringify(self.$packagePromoRecommends));
    }, 250);
    this.saveKviShoppingCart = _.debounce((newConf: KviShoppingCart, oldConf: KviShoppingCart) => {
      localStorage.setItem('kviCart', JSON.stringify(self.$kviCart));
    }, 250);
    this.saveEvents = _.debounce((newConf: Events, oldConf: Events) => {
      localStorage.setItem('events', JSON.stringify(self.$events));
    }, 250);
    this.saveResultsMonitor = _.debounce(() => {
      localStorage.setItem('resultsMonitor', JSON.stringify(self.$resultsMonitor));
    }, 250);
    this.savePackageKviRecommends = _.debounce((newConf: PackageKviRecommends, oldConf: PackageKviRecommends) => {
      localStorage.setItem('packageKviRecommends', JSON.stringify(self.$packageKviRecommends));
    }, 250);
    this.savePackageParamsInDetailReport = _.debounce((newConf: PackageParamsInDetailReport, oldConf: PackageParamsInDetailReport) => {
      localStorage.setItem('packageParamsInDetailReport', JSON.stringify(self.$packageParamsInDetailReport));
    }, 250);
    this.saveScenarioAnalysis = _.debounce((newConf: ScenarioAnalysisParams, oldConf: ScenarioAnalysisParams) => {
      localStorage.setItem('scenario', JSON.stringify(self.$scenario));
    }, 250);
  }

  setCalcData() {
    const data = localStorage.getItem('calc');
    if (data) {
      this.$calc = JSON.parse(data);
      if (!this.$calc.hasOwnProperty('depthToPurchasePrice')) {
        this.$calc.depthToPurchasePrice = 4;
      }
      const defaultData = this.getCalcDefaultData();
      if (this.$calc.priceExperiment == null) {
        this.$calc.priceExperiment = defaultData.priceExperiment;
      }
      if (this.$calc.priceExperimentSampleSize == null) {
        this.$calc.priceExperimentSampleSize = defaultData.priceExperimentSampleSize;
      }
      if (this.$calc.priceExperimentDiscountRangeFrom == null) {
        this.$calc.priceExperimentDiscountRangeFrom = defaultData.priceExperimentDiscountRangeFrom;
      }
      if (this.$calc.priceExperimentDiscountRangeTo == null) {
        this.$calc.priceExperimentDiscountRangeTo = defaultData.priceExperimentDiscountRangeTo;
      }
      if (this.$calc.priceExperimentStep == null) {
        this.$calc.priceExperimentStep = defaultData.priceExperimentStep;
      }
    } else {
      this.$calc = this.getCalcDefaultData();
    }
  }

  setResultsData() {
    const data = localStorage.getItem('results');
    if (data) {
      this.$results = JSON.parse(data);
      if (!this.$results.hasOwnProperty('depthToPurchasePrice')) {
        this.$results.depthToPurchasePrice = 4;
      }
    } else {
      this.$results = this.getResultsDefaultData();
    }
  }

  setPreCalcData() {
    const data = localStorage.getItem('preCalc');
    if (data) {
      this.$preCalc = JSON.parse(data);
      if (!this.$preCalc.hasOwnProperty('depthToPurchasePrice')) {
        this.$preCalc.depthToPurchasePrice = 4;
      }
    } else {
      this.$preCalc = this.getPreCalcDefaultData();
    }
  }

  setSetupMasterCalcData() {
    const data = localStorage.getItem('setupMasterCalc');
    if (data) {
      this.$setupMasterCalc = JSON.parse(data);
      if (!this.$setupMasterCalc.hasOwnProperty('depthToPurchasePrice')) {
        this.$setupMasterCalc.depthToPurchasePrice = 4;
      }
    } else {
      this.$setupMasterCalc = this.getCalcDefaultData();
    }
  }

  setRoundingRulesData() {
    const data = localStorage.getItem('roundingRules');
    if (data) {
      this.$roundingRules = JSON.parse(data);
    } else {
      this.$roundingRules = this.getRoundingRulesDefaultData();
    }
  }

  setEventsData() {
    const data = localStorage.getItem('events');
    if (data) {
      this.$events = JSON.parse(data);
    } else {
      this.$events = this.getEventsDefaultData();
    }
  }
  setResultsMonitorData() {
    const data = localStorage.getItem('resultsMonitor');

    if (data) {
      this.$resultsMonitor = JSON.parse(data);
    } else {
      this.$resultsMonitor = this.getResultsMonitorDefaultData();
    }
  }
  setRevaluationData() {
    const data = localStorage.getItem('revaluation');
    if (data) {
      this.$revaluation = JSON.parse(data);
    } else {
      this.$revaluation = this.getRevaluationDefaultData();
    }
  }

  setScenarioAnalysisData() {
    const data = localStorage.getItem('scenario');
    if (data) {
      this.$scenario = JSON.parse(data);
      if (!this.$scenario.hasOwnProperty('depthToPurchasePrice')) {
        this.$scenario.depthToPurchasePrice = 4;
      }
    } else {
      this.$scenario = this.getScenarioAnalysisDefaultData();
    }
  }

  setPromoData() {
    const data = localStorage.getItem('promo');
    if (data) {
      this.$promo = JSON.parse(data);
      if (!this.$promo.hasOwnProperty('purchasePrice')) {
        this.$promo.purchasePrice = null;
      }
    } else {
      this.$promo = this.getPromoDefaultData();
    }
  }

  setPackagePromoRecommendsData() {
    const data = localStorage.getItem('packagePromoRecommends');
    if (data) {
      this.$packagePromoRecommends = JSON.parse(data);
    } else {
      this.$packagePromoRecommends = this.getPackagePromoRecommendsDefaultData();
    }
  }

  setSalesData() {
    const data = localStorage.getItem('sales');
    if (data) {
      this.$sales = JSON.parse(data);
    } else {
      this.$sales = this.getSalesDefaultData();
    }
  }

  setPromotionsData() {
    const data = localStorage.getItem('promotions');
    if (data) {
      this.$promotions = JSON.parse(data);
    } else {
      this.$promotions = this.getPromotionsDefaultData();
    }
  }

  setPackageCalcData() {
    const data = localStorage.getItem('packageCalc');
    if (data) {
      this.$packageCalc = JSON.parse(data);
      if (!this.$packageCalc.hasOwnProperty('depthToPurchasePrice')) {
        this.$packageCalc.depthToPurchasePrice = 4;
      }
    } else {
      this.$packageCalc = this.getPackageCalcDefaultData();
    }
  }

  setScheduleCalcData() {
    const data = localStorage.getItem('scheduleCalc');
    if (data) {
      this.$scheduleCalc = JSON.parse(data);
      if (!this.$scheduleCalc.hasOwnProperty('depthToPurchasePrice')) {
        this.$scheduleCalc.depthToPurchasePrice = 4;
      }
    } else {
      this.$scheduleCalc = this.getPackageCalcDefaultData();
    }
  }

  setPackageKviRecommendsData() {
    const data = localStorage.getItem('packageKviRecommends');
    if (data) {
      this.$packageKviRecommends = JSON.parse(data);
    } else {
      this.$packageKviRecommends = this.getPackageKviRecommendsDefaultData();
    }
  }

  setPackageParamsInDetailReportData() {
    const data = localStorage.getItem('packageParamsInDetailReport');
    if (data) {
      this.$packageParamsInDetailReport = JSON.parse(data);
    } else {
      this.$packageParamsInDetailReport = this.getPackageParamsInDetailReportDefaultData();
    }
  }

  setPackagePromoData() {
    const data = localStorage.getItem('packagePromo');
    if (data) {
      this.$packagePromo = JSON.parse(data);
      if (!this.$packagePromo.hasOwnProperty('depthToPurchasePrice')) {
        this.$packagePromo.depthToPurchasePrice = 4;
      }
    } else {
      this.$packagePromo = this.getPackagePromoDefaultData();
    }
  }

  setKviShoppingCartData() {
    const data = localStorage.getItem('kviCart');
    if (data) {
      this.$kviCart = JSON.parse(data);
    } else {
      this.$kviCart = this.getKviShoppingCartDefaultData();
    }
  }

  applyCalcFilters(target: Calc, filters: CalcFilters) {
    target.calculationDay = filters.calculationDay;
    target.calculationDepth = filters.calculationDepth;
    target.allCheck = filters.allCheck;
    target.allClaster = filters.allClaster;
    target.discountPrice = filters.discountPrise;
    // target.pennies = filters.pennies;
    target.countAtLastPurchasePrice = filters.countAtLastPurchasePrice;
    target.countAtMaxPurchasePrice = filters.countAtMaxPurchasePrice;
    target.countAtFuturePurchasePrice = filters.countAtFuturePurchasePrice;
    // target.allNewPricesWithoutPennies = filters.allNewPricesWithoutPennies;
    target.xyzChecked = filters.xyzChecked;
    target.xyzParams = filters.spreadXYZParams;
    // target.uvwChecked = filters.uvwChecked;
    // target.uvwParams = filters.spreadUVWParams;
    target.correlation = filters.correlation;
    target.highElasticity = filters.highElasticity;
    target.intervalOfUltimateElasticity = filters.intervalOfUltimateElasticity;
    target.correlation = filters.correlation;
    target.competitorsPrices = filters.competitorsPricesParams;
    target.minProfitKVI = filters.minProfitKVI;
    target.maxProfitKVI = filters.maxProfitKVI != null ? filters.maxProfitKVI : 100;
    target.kviStrategy = this.kviStrategiesOpts.find((e) => {
      return e.value === filters.kviStrategy;
    }) as SelectBox<KviStrategies>;
    target.period = this.periodOptions.find((e) => {
      return e.value === filters.period;
    }) as SelectBox<number>;
    target.periodPriceIncreaseLimit = filters.periodPriceIncreaseLimit;
    target.percentageOfCompetitorsPrice = filters.percentageOfCompetitorsPrice;
    target.marginalProfitability = filters.marginalProfitability;
    target.marginalProfit = filters.marginalProfit;
    target.maxMarginalProfit = filters.maxMarginalProfit != null ? filters.maxMarginalProfit : 100;
    target.marginalPriceDifference = filters.marginalPriceDifference;
    target.newProductLifespanInDays = filters.newProductLifespanInDays;
    target.priceCorridor = filters.priceCorridor;
    target.changePriceCorridor = filters.changePriceCorridor;
    target.priceIncreaseLimit = filters.priceIncreaseLimit;
    target.priceDecreaseLimit = filters.priceDecreaseLimit;
    target.kviPriceDecreaseLimit = filters.kviPriceDecreaseLimit;
    target.compPriceDecreaseLimit = filters.compPriceDecreaseLimit;
    target.fixLowerBorder = filters.fixLowerBorder;
    target.depthToPurchasePrice = filters.depthToPurchasePrice;
    target.priceFamilies = filters.priceFamilies;
    target.hardPriceFamilies = filters.hardPriceFamilies;
    target.selectCoefficent = this.coefficentList.find((e) => {
      return e.value.enum === filters.priceOpt;
    }) as SelectBox<Coefficents>;
    target.useCompetitorsPrices = filters.useCompetitorsPrices;
    target.calculateCompAllowedDeviation = filters.calculateCompAllowedDeviation;
    target.byPromoPrices = filters.byPromoPrices;
    target.competitorsPricePeriod = filters.competitorsPricePeriod;
    target.competitorsCodes = filters.competitorsCodes;
    target.competitorsPriceMethod = this.competitorsPriceMethodsOpts.find((e) => {
      return e.value === filters.competitorsPriceMethod;
    }) as SelectBox<CompetitorsPriceMethods>;

    target.competitorsPriceAdjustment = filters.competitorsPriceAdjustment;
    target.competitorsInfluencesCoef = filters.competitorsInfluencesCoef;
    target.competitorsMinimumProfit = filters.competitorsMinimumProfit;
    target.competitorsMaximumProfit = filters.competitorsMaximumProfit != null ? filters.competitorsMaximumProfit : 100;
    target.competitorsControlParam = filters.competitorsControlParam;
    target.competitorsPriceStrategy = this.competitorsPriceStrategiesOpts.find((e) => {
      return e.value === filters.competitorsPriceStrategy;
    }) as SelectBox<CompetitorsPriceStrategies>;

    // target.roundKviCompetitorPrice = filters.roundKviCompetitorPrice;
    // target.roundPricesWithEqualCompStrategy = filters.roundPricesWithEqualCompStrategy;
    target.calculateByElasticity = !filters.calculateByRegression;
    target.buyerSegmentsList = filters.buyerSegments !== null ? filters.buyerSegments : [];
    target.recalculateCtm = filters.recalculateCtm;
    target.individualCommonParams = {};
    target.priceChangeLimit = filters.priceChangeLimit;
    target.priceChangeLimitKvi = filters.priceChangeLimitKvi;
    target.priceChangeLimitComp = filters.priceChangeLimitComp;
    target.calculatePYR = filters.calculatePYR;
    target.newProductPriceStrategy = this.newProductPriceStrategyOpts.find((e) => {
      return e.value === filters.newProductPriceStrategy;
    }) as SelectBox<NewProductPriceStrategy>;
    target.priceGap = filters.priceGap;
    target.priceGapCtmPc = filters.priceGapCtmPc;
    // target.randomPennies = filters.randomPennies;
    // target.manualPennies = filters.manualPennies;
    target.forecastAccuracy = filters.forecastAccuracy;
    target.percentileType = this.percentileOptions.find((e) => {
      return e.value === filters.percentileType;
    }) as SelectBox<PercentileTypes>;
    target.useAllProductBatchNumbers = filters.useAllProductBatchNumbers;
    target.competitorPriceControlParameterPc = filters.competitorPriceControlParameterPc;
    target.countPriceBySkuWithoutBatches = filters.countPriceBySkuWithoutBatches;
    target.countByAvgPurchasePrice = filters.countByAvgPurchasePrice;
    target.calcPurchasePriceByClusters = filters.calcPurchasePriceByClusters;
    target.useEmptyRemains = filters.useEmptyRemains;
    target.useArrivalDate = filters.useArrivalDate;
    target.backBasketPart = filters.backBasketPart;
    target.revaluationCalculateParams = filters.revaluationCalculateParams;
    target.checkMarginDeclineProfit = filters.checkMarginDeclineProfit;
    target.declineProfitabilityPc = filters.declineProfitabilityPc;
    target.searchPreviousPricesDepth = filters.searchPreviousPricesDepth;
    target.thompsonSampling = filters.thompsonSampling;
    target.compensateLowerTargets = filters.compensateLowerTargets;
    target.inflation = filters.inflation;
    target.calculateBySpeedSale = filters.calculateBySpeedSale;
    target.purchasePriceSuppliers = filters.purchasePriceSuppliers;
    target.purchasePriceSuppliersWithRemains = filters.purchasePriceSuppliersWithRemains;
    target.categoryOfSuppliers = this.categoryOfSuppliersOpts.find((e) => {
      return e.value === filters.categoryOfSuppliers;
    }) as SelectBox<CategoryOfSuppliers>;
    target.purchasePriceSuppliersMinProfit = filters.purchasePriceSuppliersMinProfit;
    target.purchasePriceSuppliersMinProfitForKVI = filters.purchasePriceSuppliersMinProfitForKVI;
    target.purchasePriceSuppliersMinProfitForCompetitors = filters.purchasePriceSuppliersMinProfitForCompetitors;
    target.isFixPricePromo = filters.isFixPricePromo;
    target.spreadByPriceSegments = filters.spreadByPriceSegments;
    target.applyOmnichannel = filters.applyOmnichannel;
    target.useCompElasticity = filters.useCompElasticity;
    
    // Параметры ценового эксперимента
    const defaultData = this.getCalcDefaultData();
    target.priceExperiment = filters.priceExperiment != null ? filters.priceExperiment : defaultData.priceExperiment;
    target.priceExperimentSampleSize = filters.priceExperimentSampleSize != null ? filters.priceExperimentSampleSize : defaultData.priceExperimentSampleSize;
    target.priceExperimentDiscountRangeFrom = filters.priceExperimentDiscountRangeFrom != null ? filters.priceExperimentDiscountRangeFrom : defaultData.priceExperimentDiscountRangeFrom;
    target.priceExperimentDiscountRangeTo = filters.priceExperimentDiscountRangeTo != null ? filters.priceExperimentDiscountRangeTo : defaultData.priceExperimentDiscountRangeTo;
    target.priceExperimentStep = filters.priceExperimentStep != null ? filters.priceExperimentStep : defaultData.priceExperimentStep;
    target.priceExperimentStartDate = filters.priceExperimentStartDate != null ? filters.priceExperimentStartDate : defaultData.priceExperimentStartDate;
    target.priceExperimentEndDate = filters.priceExperimentEndDate != null ? filters.priceExperimentEndDate : defaultData.priceExperimentEndDate;

    const convertStrategyValidityDate = (date?: string | number | null): string | null => {
      if (typeof date === 'number' || typeof date === 'string') {
        return moment.utc(date).local().format('YYYY-MM-DD');
      } else {
        return null;
      }
    };

    if (filters.categoryStrategy === CategoryStrategies.EMPTY) {
      target.strategyValidityBeginDate = null;
      target.strategyValidityEndDate = null;
    } else {
      target.strategyValidityBeginDate = !!filters.strategyValidityBeginDate
        ? convertStrategyValidityDate(filters.strategyValidityBeginDate)
        : defaultData.strategyValidityBeginDate;

      target.strategyValidityEndDate = !!filters.strategyValidityEndDate
        ? convertStrategyValidityDate(filters.strategyValidityEndDate)
        : defaultData.strategyValidityEndDate;
    }
    
    // Параметры автосогласования
    if (filters.autoApprovalParams) {
      target.autoApprovalParams = filters.autoApprovalParams;
    }
  }

  applyResultsFilters(target: Results, filters: CalcFilters) {
    target.calculationDay = filters.calculationDay;
    target.calculationDepth = filters.calculationDepth;
    target.allCheck = filters.allCheck;
    target.allClaster = filters.allClaster;
    // target.pennies = filters.pennies;
    target.countAtLastPurchasePrice = filters.countAtLastPurchasePrice;
    target.countAtMaxPurchasePrice = filters.countAtMaxPurchasePrice;
    target.countAtFuturePurchasePrice = filters.countAtFuturePurchasePrice;
    // target.allNewPricesWithoutPennies = filters.allNewPricesWithoutPennies;
    target.xyzChecked = filters.xyzChecked;
    target.xyzParams = filters.spreadXYZParams;
    // target.uvwChecked = filters.uvwChecked;
    // target.uvwParams = filters.spreadUVWParams;
    target.correlation = filters.correlation;
    target.highElasticity = filters.highElasticity;
    target.intervalOfUltimateElasticity = filters.intervalOfUltimateElasticity;
    target.correlation = filters.correlation;
    target.competitorsPrices = filters.competitorsPricesParams;
    target.minProfitKVI = filters.minProfitKVI;
    target.maxProfitKVI = filters.maxProfitKVI != null ? filters.maxProfitKVI : 100;
    target.kviStrategy = this.kviStrategiesOpts.find((e) => {
      return e.value === filters.kviStrategy;
    }) as SelectBox<KviStrategies>;
    target.period = this.periodOptions.find((e) => {
      return e.value === filters.period;
    }) as SelectBox<number>;
    target.periodPriceIncreaseLimit = filters.periodPriceIncreaseLimit;
    target.percentageOfCompetitorsPrice = filters.percentageOfCompetitorsPrice;
    target.marginalProfitability = filters.marginalProfitability;
    target.marginalProfit = filters.marginalProfit;
    target.maxMarginalProfit = filters.maxMarginalProfit != null ? filters.maxMarginalProfit : 100;
    target.marginalPriceDifference = filters.marginalPriceDifference;
    target.newProductLifespanInDays = filters.newProductLifespanInDays;
    target.priceCorridor = filters.priceCorridor;
    target.changePriceCorridor = filters.changePriceCorridor;
    target.priceIncreaseLimit = filters.priceIncreaseLimit;
    target.priceDecreaseLimit = filters.priceDecreaseLimit;
    target.kviPriceDecreaseLimit = filters.kviPriceDecreaseLimit;
    target.compPriceDecreaseLimit = filters.compPriceDecreaseLimit;
    target.fixLowerBorder = filters.fixLowerBorder;
    target.depthToPurchasePrice = filters.depthToPurchasePrice;
    target.priceFamilies = filters.priceFamilies;
    target.hardPriceFamilies = filters.hardPriceFamilies;
    target.selectCoefficent = this.coefficentList.find((e) => {
      return e.value.enum === filters.priceOpt;
    }) as SelectBox<Coefficents>;
    target.useCompetitorsPrices = filters.useCompetitorsPrices;
    target.competitorsPricePeriod = filters.competitorsPricePeriod;
    target.competitorsCodes = filters.competitorsCodes;
    target.competitorsPriceMethod = this.competitorsPriceMethodsOpts.find((e) => {
      return e.value === filters.competitorsPriceMethod;
    }) as SelectBox<CompetitorsPriceMethods>;

    target.competitorsPriceAdjustment = filters.competitorsPriceAdjustment;
    target.competitorsInfluencesCoef = filters.competitorsInfluencesCoef;
    target.competitorsMinimumProfit = filters.competitorsMinimumProfit;
    target.competitorsMaximumProfit = filters.competitorsMaximumProfit != null ? filters.competitorsMaximumProfit : 100;
    target.competitorsControlParam = filters.competitorsControlParam;
    target.competitorsPriceStrategy = this.competitorsPriceStrategiesOpts.find((e) => {
      return e.value === filters.competitorsPriceStrategy;
    }) as SelectBox<CompetitorsPriceStrategies>;

    // target.roundKviCompetitorPrice = filters.roundKviCompetitorPrice;
    // target.roundPricesWithEqualCompStrategy = filters.roundPricesWithEqualCompStrategy;
    target.calculateByElasticity = !filters.calculateByRegression;
    target.buyerSegmentsList = filters.buyerSegments !== null ? filters.buyerSegments : [];
    target.recalculateCtm = filters.recalculateCtm;
    target.individualCommonParams = {};
    target.priceChangeLimit = filters.priceChangeLimit;
    target.calculatePYR = filters.calculatePYR;
    target.newProductPriceStrategy = this.newProductPriceStrategyOpts.find((e) => {
      return e.value === filters.newProductPriceStrategy;
    }) as SelectBox<NewProductPriceStrategy>;
    target.priceGap = filters.priceGap;
    target.priceGapCtmPc = filters.priceGapCtmPc;
    // target.randomPennies = filters.randomPennies;
    // target.manualPennies = filters.manualPennies;
    target.forecastAccuracy = filters.forecastAccuracy;
    target.percentileType = this.percentileOptions.find((e) => {
      return e.value === filters.percentileType;
    }) as SelectBox<PercentileTypes>;
    target.useAllProductBatchNumbers = filters.useAllProductBatchNumbers;
    target.competitorPriceControlParameterPc = filters.competitorPriceControlParameterPc;
    target.countPriceBySkuWithoutBatches = filters.countPriceBySkuWithoutBatches;
    target.countByAvgPurchasePrice = filters.countByAvgPurchasePrice;
    target.calcPurchasePriceByClusters = filters.calcPurchasePriceByClusters;
    target.useEmptyRemains = filters.useEmptyRemains;
    target.useArrivalDate = filters.useArrivalDate;
    target.backBasketPart = filters.backBasketPart;
    target.revaluationCalculateParams = filters.revaluationCalculateParams;
    target.checkMarginDeclineProfit = filters.checkMarginDeclineProfit;
    target.declineProfitabilityPc = filters.declineProfitabilityPc;
    target.searchPreviousPricesDepth = filters.searchPreviousPricesDepth;
    target.thompsonSampling = filters.thompsonSampling;
    target.compensateLowerTargets = filters.compensateLowerTargets;
    target.inflation = filters.inflation;
    target.calculateBySpeedSale = filters.calculateBySpeedSale;
    target.purchasePriceSuppliers = filters.purchasePriceSuppliers;
    target.purchasePriceSuppliersWithRemains = filters.purchasePriceSuppliersWithRemains;
    target.categoryOfSuppliers = this.categoryOfSuppliersOpts.find((e) => {
      return e.value === filters.categoryOfSuppliers;
    }) as SelectBox<CategoryOfSuppliers>;
    target.purchasePriceSuppliersMinProfit = filters.purchasePriceSuppliersMinProfit;
    target.purchasePriceSuppliersMinProfitForKVI = filters.purchasePriceSuppliersMinProfitForKVI;
    target.purchasePriceSuppliersMinProfitForCompetitors = filters.purchasePriceSuppliersMinProfitForCompetitors;
  }

  applyScenarioAnalysisFilters(target: ScenarioAnalysisParams, filters: ScenarioAnalysisFilters) {
    target.calculationDay = filters.calculationDay;
    target.calculationDepth = filters.calculationDepth;
    target.allCheck = filters.allCheck;
    target.allClaster = filters.allClaster;
    target.pennies = filters.pennies;
    target.countAtMaxPurchasePrice = filters.countAtMaxPurchasePrice;
    target.countAtFuturePurchasePrice = filters.countAtFuturePurchasePrice;
    // target.allNewPricesWithoutPennies = filters.allNewPricesWithoutPennies;
    target.xyzChecked = filters.xyzChecked;
    target.xyzParams = filters.spreadXYZParams;
    // target.uvwChecked = filters.uvwChecked;
    // target.uvwParams = filters.spreadUVWParams;
    target.correlation = filters.correlation;
    target.highElasticity = filters.highElasticity;
    target.intervalOfUltimateElasticity = filters.intervalOfUltimateElasticity;
    target.correlation = filters.correlation;
    target.competitorsPrices = filters.competitorsPricesParams;
    target.minProfitKVI = filters.minProfitKVI;
    target.maxProfitKVI = filters.maxProfitKVI != null ? filters.maxProfitKVI : 100;
    target.kviStrategy = this.kviStrategiesOpts.find((e) => {
      return e.value === filters.kviStrategy;
    }) as SelectBox<KviStrategies>;
    target.period = this.periodOptions.find((e) => {
      return e.value === filters.period;
    }) as SelectBox<number>;
    target.periodPriceIncreaseLimit = filters.periodPriceIncreaseLimit;
    target.percentageOfCompetitorsPrice = filters.percentageOfCompetitorsPrice;
    target.marginalProfitability = filters.marginalProfitability;
    target.marginalProfit = filters.marginalProfit;
    target.maxMarginalProfit = filters.maxMarginalProfit != null ? filters.maxMarginalProfit : 100;
    target.marginalPriceDifference = filters.marginalPriceDifference;
    target.newProductLifespanInDays = filters.newProductLifespanInDays;
    target.priceCorridor = filters.priceCorridor;
    target.changePriceCorridor = filters.changePriceCorridor;
    target.priceIncreaseLimit = filters.priceIncreaseLimit;
    target.priceDecreaseLimit = filters.priceDecreaseLimit;
    target.kviPriceDecreaseLimit = filters.kviPriceDecreaseLimit;
    target.compPriceDecreaseLimit = filters.compPriceDecreaseLimit;
    target.fixLowerBorder = filters.fixLowerBorder;
    target.depthToPurchasePrice = filters.depthToPurchasePrice;
    target.priceFamilies = filters.priceFamilies;
    target.hardPriceFamilies = filters.hardPriceFamilies;
    target.selectCoefficent = this.coefficentList.find((e) => {
      return e.value.enum === filters.priceOpt;
    }) as SelectBox<Coefficents>;
    target.useCompetitorsPrices = filters.useCompetitorsPrices;
    target.byPromoPrices = filters.byPromoPrices;
    target.competitorsPricePeriod = filters.competitorsPricePeriod;
    target.competitorsPriceMethod = this.competitorsPriceMethodsOpts.find((e) => {
      return e.value === filters.competitorsPriceMethod;
    }) as SelectBox<CompetitorsPriceMethods>;
    target.competitorsPriceAdjustment = filters.competitorsPriceAdjustment;
    target.competitorsInfluencesCoef = filters.competitorsInfluencesCoef;
    target.competitorsMinimumProfit = filters.competitorsMinimumProfit;
    target.competitorsMaximumProfit = filters.competitorsMaximumProfit != null ? filters.competitorsMaximumProfit : 100;
    target.competitorsControlParam = filters.competitorsControlParam;
    target.competitorsPriceStrategy = this.competitorsPriceStrategiesOpts.find((e) => {
      return e.value === filters.competitorsPriceStrategy;
    }) as SelectBox<CompetitorsPriceStrategies>;
    target.roundKviCompetitorPrice = filters.roundKviCompetitorPrice;
    target.roundPricesWithEqualCompStrategy = filters.roundPricesWithEqualCompStrategy;
    target.calculateByElasticity = !filters.calculateByRegression;
    target.buyerSegmentsList = filters.buyerSegments !== null ? filters.buyerSegments : [];
    target.recalculateCtm = filters.recalculateCtm;
    target.priceChangeLimit = filters.priceChangeLimit;
    target.calculatePYR = filters.calculatePYR;
    target.newProductPriceStrategy = this.newProductPriceStrategyOpts.find((e) => {
      return e.value === filters.newProductPriceStrategy;
    }) as SelectBox<NewProductPriceStrategy>;
    target.priceGap = filters.priceGap;
    target.priceGapCtmPc = filters.priceGapCtmPc;
    target.randomPennies = filters.randomPennies;
    target.manualPennies = filters.manualPennies;
    target.forecastAccuracy = filters.forecastAccuracy;
    target.percentileType = this.percentileOptions.find((e) => {
      return e.value === filters.percentileType;
    }) as SelectBox<PercentileTypes>;
    target.useAllProductBatchNumbers = filters.useAllProductBatchNumbers;
    target.competitorPriceControlParameterPc = filters.competitorPriceControlParameterPc;
    target.useEmptyRemains = filters.useEmptyRemains;
    target.useArrivalDate = filters.useArrivalDate;
    target.backBasketPart = filters.backBasketPart;
    target.revaluationCalculateParams = filters.revaluationCalculateParams;
    target.checkMarginDeclineProfit = filters.checkMarginDeclineProfit;
    target.declineProfitabilityPc = filters.declineProfitabilityPc;
    target.searchPreviousPricesDepth = filters.searchPreviousPricesDepth;
    target.thompsonSampling = filters.thompsonSampling;
    target.compensateLowerTargets = filters.compensateLowerTargets;
  }

  applyPackageParamsInDetailReportCalcFilters(target: PackageParamsInDetailReport, filters: CalcFilters) {
    target.calculationDay = filters.calculationDay;
    target.calculationDepth = filters.calculationDepth;
    target.allCheck = filters.allCheck;
    target.allClaster = filters.allClaster;
    // target.pennies = filters.pennies;
    target.countAtLastPurchasePrice = filters.countAtLastPurchasePrice;
    target.countAtMaxPurchasePrice = filters.countAtMaxPurchasePrice;
    target.countAtFuturePurchasePrice = filters.countAtFuturePurchasePrice;
    // target.allNewPricesWithoutPennies = filters.allNewPricesWithoutPennies;
    target.xyzChecked = filters.xyzChecked;
    target.xyzParams = filters.spreadXYZParams;
    // target.uvwChecked = filters.uvwChecked;
    // target.uvwParams = filters.spreadUVWParams;
    target.correlation = filters.correlation;
    target.highElasticity = filters.highElasticity;
    target.intervalOfUltimateElasticity = filters.intervalOfUltimateElasticity;
    target.correlation = filters.correlation;
    target.competitorsPrices = filters.competitorsPricesParams;
    target.minProfitKVI = filters.minProfitKVI;
    target.maxProfitKVI = filters.maxProfitKVI != null ? filters.maxProfitKVI : 100;
    target.kviStrategy = this.kviStrategiesOpts.find((e) => {
      return e.value === filters.kviStrategy;
    }) as SelectBox<KviStrategies>;
    target.period = this.periodOptions.find((e) => {
      return e.value === filters.period;
    }) as SelectBox<number>;
    target.periodPriceIncreaseLimit = filters.periodPriceIncreaseLimit;
    target.percentageOfCompetitorsPrice = filters.percentageOfCompetitorsPrice;
    target.marginalProfitability = filters.marginalProfitability;
    target.marginalProfit = filters.marginalProfit;
    target.maxMarginalProfit = filters.maxMarginalProfit != null ? filters.maxMarginalProfit : 100;
    target.marginalPriceDifference = filters.marginalPriceDifference;
    target.newProductLifespanInDays = filters.newProductLifespanInDays;
    target.priceCorridor = filters.priceCorridor;
    target.changePriceCorridor = filters.changePriceCorridor;
    target.priceIncreaseLimit = filters.priceIncreaseLimit;
    target.fixLowerBorder = filters.fixLowerBorder;
    target.depthToPurchasePrice = filters.depthToPurchasePrice;
    target.priceFamilies = filters.priceFamilies;
    target.hardPriceFamilies = filters.hardPriceFamilies;
    target.selectCoefficent = this.coefficentList.find((e) => {
      return e.value.enum === filters.priceOpt;
    }) as SelectBox<Coefficents>;
    target.useCompetitorsPrices = filters.useCompetitorsPrices;
    target.byPromoPrices = filters.byPromoPrices;
    target.competitorsPricePeriod = filters.competitorsPricePeriod;
    target.competitorsPriceMethod = this.competitorsPriceMethodsOpts.find((e) => {
      return e.value === filters.competitorsPriceMethod;
    }) as SelectBox<CompetitorsPriceMethods>;

    target.competitorsPriceAdjustment = filters.competitorsPriceAdjustment;
    target.competitorsInfluencesCoef = filters.competitorsInfluencesCoef;
    target.competitorsMinimumProfit = filters.competitorsMinimumProfit;
    target.competitorsMaximumProfit = filters.competitorsMaximumProfit != null ? filters.competitorsMaximumProfit : 100;
    target.competitorsControlParam = filters.competitorsControlParam;
    target.competitorsPriceStrategy = this.competitorsPriceStrategiesOpts.find((e) => {
      return e.value === filters.competitorsPriceStrategy;
    }) as SelectBox<CompetitorsPriceStrategies>;

    // target.roundKviCompetitorPrice = filters.roundKviCompetitorPrice;
    // target.roundPricesWithEqualCompStrategy = filters.roundPricesWithEqualCompStrategy;
    target.calculateByElasticity = !filters.calculateByRegression;
    target.recalculateCtm = filters.recalculateCtm;
    target.priceChangeLimit = filters.priceChangeLimit;
    target.calculatePYR = filters.calculatePYR;
    target.newProductPriceStrategy = this.newProductPriceStrategyOpts.find((e) => {
      return e.value === filters.newProductPriceStrategy;
    }) as SelectBox<NewProductPriceStrategy>;
    target.priceGap = filters.priceGap;
    target.priceGapCtmPc = filters.priceGapCtmPc;
    // target.randomPennies = filters.randomPennies;
    target.countPriceBySkuWithoutBatches = filters.countPriceBySkuWithoutBatches;
    target.countByAvgPurchasePrice = filters.countByAvgPurchasePrice;
    target.calcPurchasePriceByClusters = filters.calcPurchasePriceByClusters;
    // target.manualPennies = filters.manualPennies;
    target.forecastAccuracy = filters.forecastAccuracy;
    target.useAllProductBatchNumbers = filters.useAllProductBatchNumbers;
    target.backBasketPart = filters.backBasketPart;
    target.revaluationCalculateParams = filters.revaluationCalculateParams;
    target.checkMarginDeclineProfit = filters.checkMarginDeclineProfit;
    target.declineProfitabilityPc = filters.declineProfitabilityPc;
    target.searchPreviousPricesDepth = filters.searchPreviousPricesDepth;
    target.compensateLowerTargets = filters.compensateLowerTargets;
  }

  applyPackageParamsInDetailReportPromoFilters(target: PackageParamsInDetailReport, filters: PromoFilters) {
    target.lift = filters.lift;
    target.crossCalculation = filters.crossCalculation;
    target.promoType = this.promoTypes.find((item) => {
      return item.value === filters.promoType
    }) as SelectBox<PromoType>;
    target.availableStockDelta = filters.availableStockDelta;
    target.intervalOfCorrelationElasticity = filters.intervalOfCorrelationElasticity;
    // target.randomPennies = filters.randomPennies;
  }

  applyKviCartFilters(target: KviShoppingCart, filters: KviCartFilters) {
    target.competitorsPrices = filters.competitorsPricesParams;
    target.minProfitKVI = filters.minProfitKVI;
    target.maxProfitKVI = filters.maxProfitKVI != null ? filters.maxProfitKVI : 100;
    target.kviStrategy = this.kviStrategiesOpts.find((e) => {
      return e.value === filters.kviStrategy;
    }) as SelectBox<KviStrategies>;
    target.period = this.periodOptions.find((e) => {
      return e.value === filters.period;
    }) as SelectBox<number>;
    target.periodPriceIncreaseLimit = filters.periodPriceIncreaseLimit;
    target.percentageOfCompetitorsPrice = filters.percentageOfCompetitorsPrice;
    target.marginalProfit = filters.marginalProfit;
    target.maxMarginalProfit = filters.maxMarginalProfit != null ? filters.maxMarginalProfit : 100;
    target.priceIncreaseLimit = filters.priceIncreaseLimit;
    target.fixLowerBorder = filters.fixLowerBorder;
    target.selectCoefficent = this.coefficentList.find((e) => {
      return e.value.enum === filters.priceOpt;
    }) as SelectBox<Coefficents>;
    target.useCompetitorsPrices = filters.useCompetitorsPrices;
    target.byPromoPrices = filters.byPromoPrices;
    target.competitorsPricePeriod = filters.competitorsPricePeriod;
    target.competitorsCodes = filters.competitorsCodes;
    target.competitorsPriceMethod = this.competitorsPriceMethodsOpts.find((e) => {
      return e.value === filters.competitorsPriceMethod;
    }) as SelectBox<CompetitorsPriceMethods>;
    target.kviCartChangePrices = this.kviCartChangePricesOpts.find((e) => {
      return e.value === filters.kviCartChangePrices;
    }) as SelectBox<KviCartChangePrices>;
    target.competitorsPriceAdjustment = filters.competitorsPriceAdjustment;
    target.competitorsInfluencesCoef = filters.competitorsInfluencesCoef;
    target.competitorsMinimumProfit = filters.competitorsMinimumProfit;
    target.competitorsMaximumProfit = filters.competitorsMaximumProfit != null ? filters.competitorsMaximumProfit : 100;
    target.competitorsControlParam = filters.competitorsControlParam;
    target.competitorsPriceStrategy = this.competitorsPriceStrategiesOpts.find((e) => {
      return e.value === filters.competitorsPriceStrategy;
    }) as SelectBox<CompetitorsPriceStrategies>;

    target.roundKviCompetitorPrice = filters.roundKviCompetitorPrice;
    target.roundPricesWithEqualCompStrategy = filters.roundPricesWithEqualCompStrategy;
    target.individualCommonParams = {};
    target.priceChangeLimit = filters.priceChangeLimit;
    target.priceChangeLimitKvi = filters.priceChangeLimitKvi;
    target.priceChangeLimitComp = filters.priceChangeLimitComp;
    target.percentileType = this.percentileOptions.find((e) => {
      return e.value === filters.percentileType;
    }) as SelectBox<PercentileTypes>;
    target.competitorPriceControlParameterPc = filters.competitorPriceControlParameterPc;
    target.checkMarginDeclineProfit = filters.checkMarginDeclineProfit;
    target.declineProfitabilityPc = filters.declineProfitabilityPc;
    target.searchPreviousPricesDepth = filters.searchPreviousPricesDepth;
    target.thompsonSampling = filters.thompsonSampling;
    target.useCompElasticity = filters.useCompElasticity;
    target.isFixPricePromo = filters.isFixPricePromo;
    target.calculateCompAllowedDeviation = filters.calculateCompAllowedDeviation;
    // target.revaluationCalculateParams.revaluationNumber = filters.revaluationCalculateParams.revaluationNumber;
    // target.revaluationCalculateParams.revaluationFrequencyCalculationDepth = filters.revaluationCalculateParams.revaluationFrequencyCalculationDepth;
    // target.revaluationCalculateParams.purchasePriceDelta = filters.revaluationCalculateParams.purchasePriceDelta;
    // target.revaluationCalculateParams.competitorsPriceDelta = filters.revaluationCalculateParams.competitorsPriceDelta;
    // target.revaluationCalculateParams.calculateByAllCompetitors = filters.revaluationCalculateParams.calculateByAllCompetitors;
  }

  applyBaseIndividualConfig(target: Calc, configs: CalcIndividualConfigMap) {
    for (const code of Object.keys(configs)) {
      const params = configs[code] as CalcIndividualConfig;
      const calcParams: IndividualConfig = {};
      if ('kviStrategy' in params && params.kviStrategy != null) {
        calcParams.kviStrategy = this.kviStrategiesOpts.find((e) => {
          return params.kviStrategy === e.value
        }) as SelectBox<KviStrategies>
      }

      if ('period' in params && params.period != null) {
        calcParams.period = this.periodOptions.find((e) => {
          return params.period === e.value;
        }) as SelectBox<number>
      }

      if ('marginalProfit' in params && params.marginalProfit != null) {
        calcParams.marginalProfit = params.marginalProfit;
      }

      if ('marginalProfitKvi' in params && params.marginalProfitKvi != null) {
        calcParams.marginalProfitKvi = params.marginalProfitKvi;
      }

      if ('marginalProfitCompetitors' in params && params.marginalProfitCompetitors != null) {
        calcParams.marginalProfitCompetitors = params.marginalProfitCompetitors;
      }

      if ('priceIncreaseLimit' in params && params.priceIncreaseLimit != null) {
        calcParams.priceIncreaseLimit = params.priceIncreaseLimit;
      }

      if ('competitorsPricesParams' in params && params.competitorsPricesParams != null) {
        calcParams.competitorsPricesParams = params.competitorsPricesParams;
      }

      if ('percentageOfCompetitorsPrice' in params && params.percentageOfCompetitorsPrice != null) {
        calcParams.percentageOfCompetitorsPrice = params.percentageOfCompetitorsPrice;
      }

      if ('priceOpt' in params && params.priceOpt != null) {
        calcParams.selectCoefficent = this.coefficentList.find((e) => {
          return e.value.enum === params.priceOpt;
        })
      }

      if ('priceChangeLimit' in params && params.priceChangeLimit != null) {
        calcParams.priceChangeLimit = params.priceChangeLimit;
      }

      if ('priceChangeLimitKvi' in params && params.priceChangeLimitKvi != null) {
        calcParams.priceChangeLimitKvi = params.priceChangeLimitKvi;
      }

      if ('priceChangeLimitComp' in params && params.priceChangeLimitComp != null) {
        calcParams.priceChangeLimitComp = params.priceChangeLimitComp;
      }

      if ('periodPriceIncreaseLimit' in params && params.periodPriceIncreaseLimit != null) {
        calcParams.periodPriceIncreaseLimit = params.periodPriceIncreaseLimit;
      }

      if ('newProductPriceStrategy' in params && params.newProductPriceStrategy != null) {
        calcParams.newProductPriceStrategy = this.newProductPriceStrategyOpts.find((e) => {
          return params.newProductPriceStrategy === e.value;
        }) as SelectBox<NewProductPriceStrategy>
      }

      if ('priceGap' in params && params.priceGap != null) {
        calcParams.priceGap = params.priceGap;
      }

      if ('ctmBrandPurpose' in params && params.ctmBrandPurpose != null) {
        calcParams.ctmBrandPurpose = params.ctmBrandPurpose;
      }

      if ('ctmPriceGap' in params && params.ctmPriceGap != null) {
        calcParams.ctmPriceGap = params.ctmPriceGap;
      }

      if ('competitorNames' in params) {
        calcParams.competitorNames = params.competitorNames;
      }

      if ('priceExpFlag' in params && params.priceExpFlag != null) {
        calcParams.priceExperiment = params.priceExpFlag;
      }

      target.individualCommonParams[code] = calcParams;
    }
  }

  applyKviCartIndividualConfig(target: KviShoppingCart, configs: CalcIndividualConfigMap) {
    for (const code of Object.keys(configs)) {
      const params = configs[code] as CalcIndividualConfig;
      const calcParams: IndividualConfig = {};
      if ('kviStrategy' in params && params.kviStrategy != null) {
        calcParams.kviStrategy = this.kviStrategiesOpts.find((e) => {
          return params.kviStrategy === e.value
        }) as SelectBox<KviStrategies>
      }

      if ('period' in params && params.period != null) {
        calcParams.period = this.periodOptions.find((e) => {
          return params.period === e.value;
        }) as SelectBox<number>
      }

      if ('marginalProfit' in params && params.marginalProfit != null) {
        calcParams.marginalProfit = params.marginalProfit;
      }

      if ('marginalProfitKvi' in params && params.marginalProfitKvi != null) {
        calcParams.marginalProfitKvi = params.marginalProfitKvi;
      }

      if ('marginalProfitCompetitors' in params && params.marginalProfitCompetitors != null) {
        calcParams.marginalProfitCompetitors = params.marginalProfitCompetitors;
      }

      if ('priceIncreaseLimit' in params && params.priceIncreaseLimit != null) {
        calcParams.priceIncreaseLimit = params.priceIncreaseLimit;
      }

      if ('competitorsPricesParams' in params && params.competitorsPricesParams != null) {
        calcParams.competitorsPricesParams = params.competitorsPricesParams;
      }

      if ('percentageOfCompetitorsPrice' in params && params.percentageOfCompetitorsPrice != null) {
        calcParams.percentageOfCompetitorsPrice = params.percentageOfCompetitorsPrice;
      }

      if ('priceOpt' in params && params.priceOpt != null) {
        calcParams.selectCoefficent = this.coefficentList.find((e) => {
          return e.value.enum === params.priceOpt;
        })
      }

      if ('priceChangeLimit' in params && params.priceChangeLimit != null) {
        calcParams.priceChangeLimit = params.priceChangeLimit;
      }

      if ('periodPriceIncreaseLimit' in params && params.periodPriceIncreaseLimit != null) {
        calcParams.periodPriceIncreaseLimit = params.periodPriceIncreaseLimit;
      }

      if ('competitorNames' in params) {
        calcParams.competitorNames = params.competitorNames;
      }

      this.$set(target.individualCommonParams, code, calcParams);
    }
  }

  applyPromoFilters(target: Promo, filters: PromoFilters) {
    target.selectedSkuList = filters.promoInternalCodes.map((item) => {
      return {label: item, value: item}
    });
    target.lift = filters.lift;
    target.crossCalculation = filters.crossCalculation;
    target.promoType = this.promoTypes.find((item) => {
      return item.value === filters.promoType
    }) as SelectBox<PromoType>;
    target.purchasePrice = filters.purchasePrice;
    target.availableStockDelta = filters.availableStockDelta;
    target.intervalOfCorrelationElasticity = filters.intervalOfCorrelationElasticity;
    // target.randomPennies = filters.randomPennies;
    target.thompsonSampling = filters.thompsonSampling;
    target.useSkuRotation = filters.useSkuRotation;
    target.rotationPeriodType = this.rotationPeriodTypes.find((item) => {
      return item.value === filters.rotationPeriodType
    }) as SelectBox<SkuRotationPeriodType>;
    target.promoQuoteValue = filters.promoQuote;
    target.usePromoQuote = filters.promoQuote != null;
    target.useProductRange = filters.useProductRange;
    target.promoPriceCalculationDepth = filters.promoPriceCalculationDepth;
    target.useCompetitorsPromoPrices = filters.useCompetitorsPromoPrices;
    target.calculateCompAllowedDeviationPromo = filters.calculateCompAllowedDeviationPromo;
    target.competitorPriceControlParameterPcPromo = filters.competitorPriceControlParameterPcPromo;
    target.competitorsPricePeriodPromo = filters.competitorsPricePeriodPromo;
    target.competitorsPromoPriceInfluencesCoef = filters.competitorsPromoPriceInfluencesCoef;
    target.percentileTypePromo = this.percentileTypeOpts.find((e) => {
      return e.value == filters.percentileTypePromo;
    }) as SelectBox<PercentileTypes>;
    target.competitorsPromoPriceAdjustment = filters.competitorsPromoPriceAdjustment;
    target.competitorsControlPromoParam = filters.competitorsControlPromoParam;
    target.competitorsPromoPriceMethod = this.competitorsPromoPriceMethodsOpts.find((e) => {
      return e.value === filters.competitorsPromoPriceMethod
    }) as SelectBox<CompetitorsPriceMethods>;
    target.competitorsMinimumProfitPromo = filters.competitorsMinimumProfitPromo;
    target.competitorsMaximumProfitPromo = filters.competitorsMaximumProfitPromo != null ? filters.competitorsMaximumProfitPromo : 100;
    target.competitorsPromoPriceStrategy = this.competitorsPromoPriceStrategiesOpts.find((e) => {
      return e.value === filters.competitorsPromoPriceStrategy
    }) as SelectBox<CompetitorsPriceStrategies>;
    target.planningPromoPeriodStartDate = !!filters.planningPromoPeriodStartDate
        ? moment(filters.planningPromoPeriodStartDate).format('YYYY-MM-DD')
        : '';
    target.planningPromoPeriodEndDate = !!filters.planningPromoPeriodEndDate
        ? moment(filters.planningPromoPeriodEndDate).format('YYYY-MM-DD')
        : '';
    target.useDiscountDurationForForecastCalculation = filters.useDiscountDurationForForecastCalculation;
    target.calculateCommon = filters.calculateCommon;
    target.excludeOutOfStock = filters.excludeOutOfStock;
    target.countAtFuturePurchasePrice = filters.countAtFuturePurchasePrice;
    target.calculatePYR = filters.calculatePYR;
    target.minDefaultDiscount = filters.minDefaultDiscount
    target.maxDefaultDiscount = filters.maxDefaultDiscount
  }

  applySalesFilters(target: Sales, filters: ModuleItemFilters) {
    target.calculationDay = filters.calculationDay;
    target.calculationDepth = filters.calculationDepth;
    target.allCheck = filters.allCheck;
    target.allClaster = filters.allClaster;
    target.discountPrice = filters.discountPrise;
    // target.pennies = filters.pennies;
    target.countAtLastPurchasePrice = filters.countAtLastPurchasePrice;
    target.countAtMaxPurchasePrice = filters.countAtMaxPurchasePrice;
    target.countAtFuturePurchasePrice = filters.countAtFuturePurchasePrice;
    // target.allNewPricesWithoutPennies = filters.allNewPricesWithoutPennies;
    target.xyzChecked = filters.xyzChecked;
    target.xyzParams = filters.spreadXYZParams;
    // target.uvwChecked = filters.uvwChecked;
    // target.uvwParams = filters.spreadUVWParams;
    target.correlation = filters.correlation;
    target.highElasticity = filters.highElasticity;
    target.intervalOfUltimateElasticity = filters.intervalOfUltimateElasticity;
    target.correlation = filters.correlation;
    target.competitorsPrices = filters.competitorsPricesParams;
    target.minProfitKVI = filters.minProfitKVI;
    target.maxProfitKVI = filters.maxProfitKVI != null ? filters.maxProfitKVI : 100;
    target.kviStrategy = this.kviStrategiesOpts.find((e) => {
      return e.value === filters.kviStrategy;
    }) as SelectBox<KviStrategies>;
    target.period = this.periodOptions.find((e) => {
      return e.value === filters.period;
    }) as SelectBox<number>;
    target.periodPriceIncreaseLimit = filters.periodPriceIncreaseLimit;
    target.percentageOfCompetitorsPrice = filters.percentageOfCompetitorsPrice;
    target.marginalProfitability = filters.marginalProfitability;
    target.marginalProfit = filters.marginalProfit;
    target.maxMarginalProfit = filters.maxMarginalProfit != null ? filters.maxMarginalProfit : 100;
    target.marginalPriceDifference = filters.marginalPriceDifference;
    target.newProductLifespanInDays = filters.newProductLifespanInDays;
    target.priceCorridor = filters.priceCorridor;
    target.changePriceCorridor = filters.changePriceCorridor;
    target.priceIncreaseLimit = filters.priceIncreaseLimit;
    target.priceDecreaseLimit = filters.priceDecreaseLimit;
    target.kviPriceDecreaseLimit = filters.kviPriceDecreaseLimit;
    target.compPriceDecreaseLimit = filters.compPriceDecreaseLimit;
    target.fixLowerBorder = filters.fixLowerBorder;
    target.depthToPurchasePrice = filters.depthToPurchasePrice;
    target.priceFamilies = filters.priceFamilies;
    target.hardPriceFamilies = filters.hardPriceFamilies;
    target.selectCoefficent = this.coefficentList.find((e) => {
      return e.value.enum === filters.priceOpt;
    }) as SelectBox<Coefficents>;
    target.useCompetitorsPrices = filters.useCompetitorsPrices;
    target.calculateCompAllowedDeviation = filters.calculateCompAllowedDeviation;
    target.byPromoPrices = filters.byPromoPrices;
    target.competitorsPricePeriod = filters.competitorsPricePeriod;
    target.competitorsCodes = filters.competitorsCodes;
    target.competitorsPriceMethod = this.competitorsPriceMethodsOpts.find((e) => {
      return e.value === filters.competitorsPriceMethod;
    }) as SelectBox<CompetitorsPriceMethods>;

    target.competitorsPriceAdjustment = filters.competitorsPriceAdjustment;
    target.competitorsInfluencesCoef = filters.competitorsInfluencesCoef;
    target.competitorsMinimumProfit = filters.competitorsMinimumProfit;
    target.competitorsMaximumProfit = filters.competitorsMaximumProfit != null ? filters.competitorsMaximumProfit : 100;
    target.competitorsControlParam = filters.competitorsControlParam;
    target.competitorsPriceStrategy = this.competitorsPriceStrategiesOpts.find((e) => {
      return e.value === filters.competitorsPriceStrategy;
    }) as SelectBox<CompetitorsPriceStrategies>;

    // target.roundKviCompetitorPrice = filters.roundKviCompetitorPrice;
    // target.roundPricesWithEqualCompStrategy = filters.roundPricesWithEqualCompStrategy;
    target.calculateByElasticity = !filters.calculateByRegression;
    target.buyerSegmentsList = filters.buyerSegments !== null ? filters.buyerSegments : [];
    target.recalculateCtm = filters.recalculateCtm;
    target.individualCommonParams = {};
    target.priceChangeLimit = filters.priceChangeLimit;
    target.priceChangeLimitKvi = filters.priceChangeLimitKvi;
    target.priceChangeLimitComp = filters.priceChangeLimitComp;
    target.calculatePYR = filters.calculatePYR;
    target.newProductPriceStrategy = this.newProductPriceStrategyOpts.find((e) => {
      return e.value === filters.newProductPriceStrategy;
    }) as SelectBox<NewProductPriceStrategy>;
    target.priceGap = filters.priceGap;
    target.priceGapCtmPc = filters.priceGapCtmPc;
    // target.randomPennies = filters.randomPennies;
    // target.manualPennies = filters.manualPennies;
    target.forecastAccuracy = filters.forecastAccuracy;
    target.percentileType = this.percentileOptions.find((e) => {
      return e.value === filters.percentileType;
    }) as SelectBox<PercentileTypes>;
    target.useAllProductBatchNumbers = filters.useAllProductBatchNumbers;
    target.competitorPriceControlParameterPc = filters.competitorPriceControlParameterPc;
    target.countPriceBySkuWithoutBatches = filters.countPriceBySkuWithoutBatches;
    target.countByAvgPurchasePrice = filters.countByAvgPurchasePrice;
    target.calcPurchasePriceByClusters = filters.calcPurchasePriceByClusters;
    target.useEmptyRemains = filters.useEmptyRemains;
    target.useArrivalDate = filters.useArrivalDate;
    target.backBasketPart = filters.backBasketPart;
    target.revaluationCalculateParams = filters.revaluationCalculateParams;
    target.checkMarginDeclineProfit = filters.checkMarginDeclineProfit;
    target.declineProfitabilityPc = filters.declineProfitabilityPc;
    target.searchPreviousPricesDepth = filters.searchPreviousPricesDepth;
    target.thompsonSampling = filters.thompsonSampling;
    target.compensateLowerTargets = filters.compensateLowerTargets;
    target.inflation = filters.inflation;
    target.calculateBySpeedSale = filters.calculateBySpeedSale;
    target.purchasePriceSuppliers = filters.purchasePriceSuppliers;
    target.purchasePriceSuppliersWithRemains = filters.purchasePriceSuppliersWithRemains;
    target.categoryOfSuppliers = this.categoryOfSuppliersOpts.find((e) => {
      return e.value === filters.categoryOfSuppliers;
    }) as SelectBox<CategoryOfSuppliers>;
    target.purchasePriceSuppliersMinProfit = filters.purchasePriceSuppliersMinProfit;
    target.purchasePriceSuppliersMinProfitForKVI = filters.purchasePriceSuppliersMinProfitForKVI;
    target.purchasePriceSuppliersMinProfitForCompetitors = filters.purchasePriceSuppliersMinProfitForCompetitors;
    target.isFixPricePromo = filters.isFixPricePromo;
    target.spreadByPriceSegments = filters.spreadByPriceSegments;
    target.applyOmnichannel = filters.applyOmnichannel;
    target.useCompElasticity = filters.useCompElasticity;
    target.useProductRange = filters.useProductRange;
    target.useCompetitorsPromoPrices = filters.useCompetitorsPromoPrices;
    target.calculateCompAllowedDeviationPromo = filters.calculateCompAllowedDeviationPromo;
    target.competitorPriceControlParameterPcPromo = filters.competitorPriceControlParameterPcPromo;
    target.competitorsPromoPriceInfluencesCoef = filters.competitorsPromoPriceInfluencesCoef;
    target.percentileTypePromo = filters.percentileTypePromo;
    target.competitorsPromoPriceAdjustment = filters.competitorsPromoPriceAdjustment;
    target.competitorsControlPromoParam = filters.competitorsControlPromoParam;
    target.availableStockDelta = filters.availableStockDelta;
    target.intervalOfCorrelationElasticity = filters.intervalOfCorrelationElasticity;
    target.competitorsPromoPriceMethod = this.competitorsPromoPriceMethodsOpts.find((e) => {
      return e.value === filters.competitorsPromoPriceMethod
    }) as SelectBox<CompetitorsPriceMethods>;
    target.competitorsMinimumProfitPromo = filters.competitorsMinimumProfitPromo;
    target.competitorsMaximumProfitPromo = filters.competitorsMaximumProfitPromo != null ? filters.competitorsMaximumProfitPromo : 100;
    target.competitorsPromoPriceStrategy = this.competitorsPromoPriceStrategiesOpts.find((e) => {
      return e.value === filters.competitorsPromoPriceStrategy
    }) as SelectBox<CompetitorsPriceStrategies>;
    target.promoPriceCalculationDepth = filters.promoPriceCalculationDepth;
    target.minPromoPrice = filters.minPromoPrice;
    target.lift = filters.lift;
    target.considerPlannedSeason = filters.considerPlannedSeason;
    target.useDiscountDurationForForecastCalculation = filters.useDiscountDurationForForecastCalculation;
    target.useSkuRotation = filters.useSkuRotation;
    target.crossCalculation = filters.crossCalculation;
    target.calculateCommon = filters.calculateCommon;
    target.excludeOutOfStock = filters.excludeOutOfStock;
    target.calculateBySalePoints = filters.calculateBySalePoints;
    target.calculateBySubcategories = filters.calculateBySubcategories!;
    target.trainModel = filters.trainModel;
    target.rotationPeriodType = filters.rotationPeriodType;
  }

  applyPromotionsFilters(target: Promotions, filters: ModuleItemFilters) {
    target.calculationDay = filters.calculationDay;
    target.calculationDepth = filters.calculationDepth;
    target.allCheck = filters.allCheck;
    target.allClaster = filters.allClaster;
    target.discountPrice = filters.discountPrise;
    // target.pennies = filters.pennies;
    target.countAtLastPurchasePrice = filters.countAtLastPurchasePrice;
    target.countAtMaxPurchasePrice = filters.countAtMaxPurchasePrice;
    target.countAtFuturePurchasePrice = filters.countAtFuturePurchasePrice;
    // target.allNewPricesWithoutPennies = filters.allNewPricesWithoutPennies;
    target.xyzChecked = filters.xyzChecked;
    target.xyzParams = filters.spreadXYZParams;
    // target.uvwChecked = filters.uvwChecked;
    // target.uvwParams = filters.spreadUVWParams;
    target.correlation = filters.correlation;
    target.highElasticity = filters.highElasticity;
    target.intervalOfUltimateElasticity = filters.intervalOfUltimateElasticity;
    target.correlation = filters.correlation;
    target.competitorsPrices = filters.competitorsPricesParams;
    target.minProfitKVI = filters.minProfitKVI;
    target.maxProfitKVI = filters.maxProfitKVI != null ? filters.maxProfitKVI : 100;
    target.kviStrategy = this.kviStrategiesOpts.find((e) => {
      return e.value === filters.kviStrategy;
    }) as SelectBox<KviStrategies>;
    target.period = this.periodOptions.find((e) => {
      return e.value === filters.period;
    }) as SelectBox<number>;
    target.periodPriceIncreaseLimit = filters.periodPriceIncreaseLimit;
    target.percentageOfCompetitorsPrice = filters.percentageOfCompetitorsPrice;
    target.marginalProfitability = filters.marginalProfitability;
    target.marginalProfit = filters.marginalProfit;
    target.maxMarginalProfit = filters.maxMarginalProfit != null ? filters.maxMarginalProfit : 100;
    target.marginalPriceDifference = filters.marginalPriceDifference;
    target.newProductLifespanInDays = filters.newProductLifespanInDays;
    target.priceCorridor = filters.priceCorridor;
    target.changePriceCorridor = filters.changePriceCorridor;
    target.priceIncreaseLimit = filters.priceIncreaseLimit;
    target.priceDecreaseLimit = filters.priceDecreaseLimit;
    target.kviPriceDecreaseLimit = filters.kviPriceDecreaseLimit;
    target.compPriceDecreaseLimit = filters.compPriceDecreaseLimit;
    target.fixLowerBorder = filters.fixLowerBorder;
    target.depthToPurchasePrice = filters.depthToPurchasePrice;
    target.priceFamilies = filters.priceFamilies;
    target.hardPriceFamilies = filters.hardPriceFamilies;
    target.selectCoefficent = this.coefficentList.find((e) => {
      return e.value.enum === filters.priceOpt;
    }) as SelectBox<Coefficents>;
    target.useCompetitorsPrices = filters.useCompetitorsPrices;
    target.calculateCompAllowedDeviation = filters.calculateCompAllowedDeviation;
    target.byPromoPrices = filters.byPromoPrices;
    target.competitorsPricePeriod = filters.competitorsPricePeriod;
    target.competitorsCodes = filters.competitorsCodes;
    target.competitorsPriceMethod = this.competitorsPriceMethodsOpts.find((e) => {
      return e.value === filters.competitorsPriceMethod;
    }) as SelectBox<CompetitorsPriceMethods>;

    target.competitorsPriceAdjustment = filters.competitorsPriceAdjustment;
    target.competitorsInfluencesCoef = filters.competitorsInfluencesCoef;
    target.competitorsMinimumProfit = filters.competitorsMinimumProfit;
    target.competitorsMaximumProfit = filters.competitorsMaximumProfit != null ? filters.competitorsMaximumProfit : 100;
    target.competitorsControlParam = filters.competitorsControlParam;
    target.competitorsPriceStrategy = this.competitorsPriceStrategiesOpts.find((e) => {
      return e.value === filters.competitorsPriceStrategy;
    }) as SelectBox<CompetitorsPriceStrategies>;

    // target.roundKviCompetitorPrice = filters.roundKviCompetitorPrice;
    // target.roundPricesWithEqualCompStrategy = filters.roundPricesWithEqualCompStrategy;
    target.calculateByElasticity = !filters.calculateByRegression;
    target.buyerSegmentsList = filters.buyerSegments !== null ? filters.buyerSegments : [];
    target.recalculateCtm = filters.recalculateCtm;
    target.individualCommonParams = {};
    target.priceChangeLimit = filters.priceChangeLimit;
    target.priceChangeLimitKvi = filters.priceChangeLimitKvi;
    target.priceChangeLimitComp = filters.priceChangeLimitComp;
    target.calculatePYR = filters.calculatePYR;
    target.newProductPriceStrategy = this.newProductPriceStrategyOpts.find((e) => {
      return e.value === filters.newProductPriceStrategy;
    }) as SelectBox<NewProductPriceStrategy>;
    target.priceGap = filters.priceGap;
    target.priceGapCtmPc = filters.priceGapCtmPc;
    // target.randomPennies = filters.randomPennies;
    // target.manualPennies = filters.manualPennies;
    target.forecastAccuracy = filters.forecastAccuracy;
    target.percentileType = this.percentileOptions.find((e) => {
      return e.value === filters.percentileType;
    }) as SelectBox<PercentileTypes>;
    target.useAllProductBatchNumbers = filters.useAllProductBatchNumbers;
    target.competitorPriceControlParameterPc = filters.competitorPriceControlParameterPc;
    target.countPriceBySkuWithoutBatches = filters.countPriceBySkuWithoutBatches;
    target.countByAvgPurchasePrice = filters.countByAvgPurchasePrice;
    target.calcPurchasePriceByClusters = filters.calcPurchasePriceByClusters;
    target.useEmptyRemains = filters.useEmptyRemains;
    target.useArrivalDate = filters.useArrivalDate;
    target.backBasketPart = filters.backBasketPart;
    target.revaluationCalculateParams = filters.revaluationCalculateParams;
    target.checkMarginDeclineProfit = filters.checkMarginDeclineProfit;
    target.declineProfitabilityPc = filters.declineProfitabilityPc;
    target.searchPreviousPricesDepth = filters.searchPreviousPricesDepth;
    target.thompsonSampling = filters.thompsonSampling;
    target.compensateLowerTargets = filters.compensateLowerTargets;
    target.inflation = filters.inflation;
    target.calculateBySpeedSale = filters.calculateBySpeedSale;
    target.purchasePriceSuppliers = filters.purchasePriceSuppliers;
    target.purchasePriceSuppliersWithRemains = filters.purchasePriceSuppliersWithRemains;
    target.categoryOfSuppliers = this.categoryOfSuppliersOpts.find((e) => {
      return e.value === filters.categoryOfSuppliers;
    }) as SelectBox<CategoryOfSuppliers>;
    target.purchasePriceSuppliersMinProfit = filters.purchasePriceSuppliersMinProfit;
    target.purchasePriceSuppliersMinProfitForKVI = filters.purchasePriceSuppliersMinProfitForKVI;
    target.purchasePriceSuppliersMinProfitForCompetitors = filters.purchasePriceSuppliersMinProfitForCompetitors;
    target.isFixPricePromo = filters.isFixPricePromo;
    target.spreadByPriceSegments = filters.spreadByPriceSegments;
    target.applyOmnichannel = filters.applyOmnichannel;
    target.useCompElasticity = filters.useCompElasticity;
    target.useProductRange = filters.useProductRange;
    target.useCompetitorsPromoPrices = filters.useCompetitorsPromoPrices;
    target.calculateCompAllowedDeviationPromo = filters.calculateCompAllowedDeviationPromo;
    target.competitorPriceControlParameterPcPromo = filters.competitorPriceControlParameterPcPromo;
    target.competitorsPromoPriceInfluencesCoef = filters.competitorsPromoPriceInfluencesCoef;
    target.percentileTypePromo = filters.percentileTypePromo;
    target.competitorsPromoPriceAdjustment = filters.competitorsPromoPriceAdjustment;
    target.competitorsControlPromoParam = filters.competitorsControlPromoParam;
    target.availableStockDelta = filters.availableStockDelta;
    target.intervalOfCorrelationElasticity = filters.intervalOfCorrelationElasticity;
    target.competitorsPromoPriceMethod = this.competitorsPromoPriceMethodsOpts.find((e) => {
      return e.value === filters.competitorsPromoPriceMethod
    }) as SelectBox<CompetitorsPriceMethods>;
    target.competitorsMinimumProfitPromo = filters.competitorsMinimumProfitPromo;
    target.competitorsMaximumProfitPromo = filters.competitorsMaximumProfitPromo != null ? filters.competitorsMaximumProfitPromo : 100;
    target.competitorsPromoPriceStrategy = this.competitorsPromoPriceStrategiesOpts.find((e) => {
      return e.value === filters.competitorsPromoPriceStrategy
    }) as SelectBox<CompetitorsPriceStrategies>;
    target.promoPriceCalculationDepth = filters.promoPriceCalculationDepth;
    target.minPromoPrice = filters.minPromoPrice;
    target.lift = filters.lift;
    // target.considerPlannedSeason = filters.considerPlannedSeason;
    target.useDiscountDurationForForecastCalculation = filters.useDiscountDurationForForecastCalculation;
    // target.useSkuRotation = filters.useSkuRotation;
    // target.crossCalculation = filters.crossCalculation;
    // target.calculateCommon = filters.calculateCommon;
    target.excludeOutOfStock = filters.excludeOutOfStock;
    target.calculateBySalePoints = filters.calculateBySalePoints;
    target.trainModel = filters.trainModel;
    target.considerCannibalization = filters.considerCannibalization;
    target.rotationPeriodType = filters.rotationPeriodType;
  }

  applyPromoIndividualConfig(target: Promo, configs: PromoIndividualConfigMap) {
    for (const code of Object.keys(configs)) {
      const params = configs[code] as PromoServerIndividualConfig;
      const promoParams: PromoIndividualConfig = {};

      if ('lift' in params && params.lift != null) {
        promoParams.lift = params.lift;
      }

      if ('promoType' in params && params.promoType != null) {
        promoParams.promoType = this.promoTypes.find((e) => {
          return (e.value === params.promoType);
        }) as SelectBox<PromoType>
      }

      if ('purchasePrice' in params && params.purchasePrice != null) {
        promoParams.purchasePrice = params.purchasePrice
      }

      target.individualPromoConfig[code] = promoParams;
    }
  }

  applySalesIndividualConfig(target: Sales, configs: SaleIndividualConfigMap) {
    for (const code of Object.keys(configs)) {
      const params = configs[code] as SaleServerIndividualConfig;
      const saleParams: SaleIndividualConfig = {};

      if ('minPrice' in params && params.minPrice != null) {
        saleParams.minPrice = params.minPrice;
      }

      if ('maxPrice' in params && params.maxPrice != null) {
        saleParams.maxPrice = params.maxPrice;
      }

      if ('minProfitability' in params && params.minProfitability != null) {
        saleParams.minProfitability = params.minProfitability;
      }

      if ('minDiscount' in params && params.minDiscount != null) {
        saleParams.minDiscount = params.minDiscount;
      }

      if ('maxDiscount' in params && params.maxDiscount != null) {
        saleParams.maxDiscount = params.maxDiscount;
      }

      if ('remains' in params && params.remains != null) {
        saleParams.remains = params.remains;
      }

      target.individualSaleConfig[code] = saleParams;
      target.individualConfig[code] = saleParams;
    }
  }

  applyPromotionsIndividualConfig(target: Promotions, configs: PromotionIndividualConfigMap) {
    for (const code of Object.keys(configs)) {
      const params = configs[code] as PromotionsServerIndividualConfig;
      const promotionsParams: PromotionIndividualConfig = {};

      if ('minPrice' in params && params.minPrice != null) {
        promotionsParams.minPrice = params.minPrice;
      }

      if ('maxPrice' in params && params.maxPrice != null) {
        promotionsParams.maxPrice = params.maxPrice;
      }

      if ('minProfitability' in params && params.minProfitability != null) {
        promotionsParams.minProfitability = params.minProfitability;
      }

      if ('minDiscount' in params && params.minDiscount != null) {
        promotionsParams.minDiscount = params.minDiscount;
      }

      if ('maxDiscount' in params && params.maxDiscount != null) {
        promotionsParams.maxDiscount = params.maxDiscount;
      }

      if ('remains' in params && params.remains != null) {
        promotionsParams.remains = params.remains;
      }

      target.individualSaleConfig[code] = promotionsParams; // TODO в будущем убрать
      target.individualConfig[code] = promotionsParams;
    }
  }

  getStringToSign(obj: any, excludeFields: string[]): string {
    let stringToSign = '';
    Object.keys(obj).sort().forEach((key) => {
      const objElement = obj[key];
      if (!excludeFields.includes(key) && objElement != null) {
        if (typeof objElement === 'object') {
          stringToSign += key;
          stringToSign += this.getStringToSign(objElement, []);
        } else {
          if (typeof objElement === 'number') {
            const numb = objElement * 100;
            stringToSign += `${key}${numb}`
          } else {
            stringToSign += `${key}${objElement}`
          }
        }
      }
    });
    return stringToSign;
  }

  resetCalcData(fullReset = true) {
    localStorage.removeItem('calc');
    if (fullReset) {
      this.$calc = this.getCalcDefaultData();
    } else {
      const calc = this.getCalcDefaultData();
      calc.selectMarket = this.$calc.selectMarket;
      calc.categoryOfProduct = this.$calc.categoryOfProduct;
      calc.groupOfProduct = this.$calc.groupOfProduct;
      calc.subcategories = this.$calc.subcategories;
      calc.productSegments = this.$calc.productSegments;
      calc.formatSelected = this.$calc.formatSelected;
      calc.regionSelected = this.$calc.regionSelected;
      calc.clusterSelected = this.$calc.clusterSelected;
      calc.seasonSelected = this.$calc.seasonSelected;
      this.$calc = calc;
    }
  }

  resetResultsData(fullReset = true) {
    localStorage.removeItem('results');
    if (fullReset) {
      this.$results = this.getResultsDefaultData();
    } else {
      const results = this.getResultsDefaultData();
      results.selectMarket = this.$results.selectMarket;
      results.categoryOfProduct = this.$results.categoryOfProduct;
      results.groupOfProduct = this.$results.groupOfProduct;
      results.subcategories = this.$results.subcategories;
      results.formatSelected = this.$results.formatSelected;
      results.regionSelected = this.$results.regionSelected;
      results.clusterSelected = this.$results.clusterSelected;
      results.seasonSelected = this.$results.seasonSelected;
      this.$results = results;
    }
  }

  resetPreCalcData(fullReset = true) {
    localStorage.removeItem('preCalc');
    if (fullReset) {
      this.$preCalc = this.getPreCalcDefaultData();
    } else {
      const preCalc = this.getPreCalcDefaultData();
      preCalc.selectMarket = this.$preCalc.selectMarket;
      preCalc.categoryOfProduct = this.$preCalc.categoryOfProduct;
      preCalc.groupOfProduct = this.$preCalc.groupOfProduct;
      preCalc.subcategories = this.$preCalc.subcategories;
      preCalc.formatSelected = this.$preCalc.formatSelected;
      preCalc.regionSelected = this.$preCalc.regionSelected;
      preCalc.clusterSelected = this.$preCalc.clusterSelected;
      preCalc.seasonSelected = this.$preCalc.seasonSelected;
      this.$preCalc = preCalc;
    }
  }

  resetRoundingRulesData(fullReset = true) {
    localStorage.removeItem('roundingRules');
    if (fullReset) {
      this.$roundingRules = this.getRoundingRulesDefaultData();
    } else {
      const calc = this.getRoundingRulesDefaultData();
      calc.selectMarket = this.$roundingRules.selectMarket;
      calc.categoryOfProduct = this.$roundingRules.categoryOfProduct;
      calc.groupOfProduct = this.$roundingRules.groupOfProduct;
      calc.subcategories = this.$roundingRules.subcategories;
      calc.formatSelected = this.$roundingRules.formatSelected;
      calc.regionSelected = this.$roundingRules.regionSelected;
      calc.clusterSelected = this.$roundingRules.clusterSelected;
      calc.seasonSelected = this.$roundingRules.seasonSelected;
      this.$roundingRules = calc;
    }
  }

  resetSetupMasterCalcData(fullReset = true) {
    localStorage.removeItem('setupMasterCalc');
    if (fullReset) {
      this.$setupMasterCalc = this.getCalcDefaultData();
    } else {
      const calc = this.getCalcDefaultData();
      calc.selectMarket = this.$setupMasterCalc.selectMarket;
      calc.categoryOfProduct = this.$setupMasterCalc.categoryOfProduct;
      calc.groupOfProduct = this.$setupMasterCalc.groupOfProduct;
      calc.subcategories = this.$setupMasterCalc.subcategories;
      calc.formatSelected = this.$setupMasterCalc.formatSelected;
      calc.regionSelected = this.$setupMasterCalc.regionSelected;
      calc.clusterSelected = this.$setupMasterCalc.clusterSelected;
      calc.seasonSelected = this.$setupMasterCalc.seasonSelected;
      calc.productSegments = this.$setupMasterCalc.productSegments
      this.$setupMasterCalc = calc;
    }
  }

  resetScenarioAnalysisData(fullReset = true) {
    localStorage.removeItem('scenario');
    if (fullReset) {
      this.$scenario = this.getScenarioAnalysisDefaultData();
    } else {
      const scenario = this.getScenarioAnalysisDefaultData();
      scenario.selectMarket = this.$scenario.selectMarket;
      scenario.categoryOfProduct = this.$scenario.categoryOfProduct;
      scenario.groupOfProduct = this.$scenario.groupOfProduct;
      scenario.subcategories = this.$scenario.subcategories;
      scenario.formatSelected = this.$scenario.formatSelected;
      scenario.regionSelected = this.$scenario.regionSelected;
      scenario.clusterSelected = this.$scenario.clusterSelected;
      scenario.seasonSelected = this.$scenario.seasonSelected;
      scenario.productSegments = this.$scenario.productSegments
      this.$scenario = scenario;
    }
  }

  resetPromoData(fullReset = true) {
    localStorage.removeItem('promo');
    if (fullReset) {
      this.$promo = this.getPromoDefaultData();
    } else {
      const promo = this.getPromoDefaultData();
      promo.selectMarket = this.$promo.selectMarket;
      promo.groupOfProduct = this.$promo.groupOfProduct;
      promo.categoryOfProduct = this.$promo.categoryOfProduct;
      promo.subcategories = this.$promo.subcategories;
      promo.formatSelected = this.$promo.formatSelected;
      promo.regionSelected = this.$promo.regionSelected;
      promo.clusterSelected = this.$promo.clusterSelected;
      promo.seasonSelected = this.$promo.seasonSelected;
      promo.productSegments = this.$promo.productSegments
      this.$promo = promo;
    }
  }

  resetPackagePromoRecommendsData(fullReset = true) {
    localStorage.removeItem('packagePromoRecommends');
    if (fullReset) {
      this.$packagePromoRecommends = this.getPackagePromoRecommendsDefaultData();
    } else {
      const packagePromoRecommends = this.getPackagePromoRecommendsDefaultData();
      packagePromoRecommends.selectMarket = this.$packagePromoRecommends.selectMarket;
      packagePromoRecommends.categoriesOfProduct = this.$packagePromoRecommends.categoriesOfProduct;
      packagePromoRecommends.groupsOfProduct = this.$packagePromoRecommends.groupsOfProduct;
      packagePromoRecommends.subcategories = this.$packagePromoRecommends.subcategories;
      packagePromoRecommends.formatSelected = this.$packagePromoRecommends.formatSelected;
      packagePromoRecommends.regionSelected = this.$packagePromoRecommends.regionSelected;
      packagePromoRecommends.clusterSelected = this.$packagePromoRecommends.clusterSelected;
      packagePromoRecommends.seasonSelected = this.$packagePromoRecommends.seasonSelected;
      this.$packagePromoRecommends = packagePromoRecommends;
    }
  }

  resetSalesData(fullReset = true) {
    localStorage.removeItem('sales');
    localStorage.removeItem('salesActiveTabKey');

    if (fullReset) {
      this.$sales = this.getSalesDefaultData();
    } else {
      const sales = this.getSalesDefaultData();

      sales.selectMarket = this.$sales.selectMarket;
      sales.groupIds = this.$sales.groupIds;
      sales.categoryIds = this.$sales.categoryIds;
      sales.subcategories = this.$sales.subcategories;
      sales.formatSelected = this.$sales.formatSelected;
      sales.regionIds = this.$sales.regionIds;
      sales.clusterIds = this.$sales.clusterIds;
      sales.seasonSelected = this.$sales.seasonSelected;
      sales.productSegments = this.$sales.productSegments;

      this.$sales = sales;
    }
  }

  resetPromotionsData(fullReset = true) {
    localStorage.removeItem('promotions');
    localStorage.removeItem('promotionsActiveTabKey');

    if (fullReset) {
      this.$promotions = this.getPromotionsDefaultData();
    } else {
      const promotions = this.getPromotionsDefaultData();

      promotions.selectMarket = this.$promotions.selectMarket;
      promotions.groupIds = this.$promotions.groupIds;
      promotions.categoryIds = this.$promotions.categoryIds;
      promotions.subcategories = this.$promotions.subcategories;
      promotions.formatSelected = this.$promotions.formatSelected;
      promotions.regionIds = this.$promotions.regionIds;
      promotions.clusterIds = this.$promotions.clusterIds;
      promotions.seasonSelected = this.$promotions.seasonSelected;
      promotions.productSegments = this.$promotions.productSegments;

      this.$promotions = promotions;
    }
  }

  resetKviShoppingCartData(fullReset = true) {
    localStorage.removeItem('kviCart');
    if (fullReset) {
      this.$kviCart = this.getKviShoppingCartDefaultData();
    } else {
      const kviCart = this.getKviShoppingCartDefaultData();
      kviCart.selectMarket = this.$kviCart.selectMarket;
      kviCart.categoryOfProduct = this.$kviCart.categoryOfProduct;
      kviCart.formatSelected = this.$kviCart.formatSelected;
      kviCart.regionSelected = this.$kviCart.regionSelected;
      kviCart.clusterSelected = this.$kviCart.clusterSelected;
      kviCart.productSegments = this.$kviCart.productSegments
      this.$kviCart = kviCart;
    }
  }

  resetPackageCalcData(fullReset = true) {
    localStorage.removeItem('packageCalc');
    if (fullReset) {
      this.$packageCalc = this.getPackageCalcDefaultData();
    } else {
      const packageCalc = this.getPackageCalcDefaultData();
      packageCalc.selectMarket = this.$packageCalc.selectMarket;
      packageCalc.categoriesOfProduct = this.$packageCalc.categoriesOfProduct;
      packageCalc.groupsOfProduct = this.$packageCalc.groupsOfProduct;
      packageCalc.subcategories = this.$packageCalc.subcategories;
      packageCalc.formatSelected = this.$packageCalc.formatSelected;
      packageCalc.regionSelected = this.$packageCalc.regionSelected;
      packageCalc.clusterSelected = this.$packageCalc.clusterSelected;
      packageCalc.seasonSelected = this.$packageCalc.seasonSelected;
      packageCalc.productSegments = this.$packageCalc.productSegments;
      this.$packageCalc = packageCalc;
    }
  }

  resetRevaluationData(fullReset = true) {
    localStorage.removeItem('revaluation');
    if (fullReset) {
      this.$revaluation = this.getRevaluationDefaultData();
    } else {
      const revaluation = this.getRevaluationDefaultData();
      revaluation.selectMarket = this.$revaluation.selectMarket;
      revaluation.categoriesOfProduct = this.$revaluation.categoriesOfProduct;
      revaluation.subcategories = this.$revaluation.subcategories;
      revaluation.formatSelected = this.$revaluation.formatSelected;
      revaluation.regionSelected = this.$revaluation.regionSelected;
      revaluation.clusterSelected = this.$revaluation.clusterSelected;
      revaluation.seasonSelected = this.$revaluation.seasonSelected;
      revaluation.productSegments = this.$revaluation.productSegments;
      this.$revaluation = revaluation;
    }
  }

  resetEventsData(fullReset = true) {
    localStorage.removeItem('events');
    if (fullReset) {
      this.$events = this.getEventsDefaultData();
    } else {
      const events = this.getEventsDefaultData();
      events.selectMarket = this.$events.selectMarket;
      events.groupsOfProduct = this.$events.groupsOfProduct;
      events.categoriesOfProduct = this.$events.categoriesOfProduct;
      events.subcategories = this.$events.subcategories;
      events.formatSelected = this.$events.formatSelected;
      events.productSegments = this.$events.productSegments;
      this.$events = events;
    }
  }

  resetResultsMonitorData(fullReset = true) {
    localStorage.removeItem('resultsMonitor');

    if (fullReset) {
      this.$resultsMonitor = this.getResultsMonitorDefaultData();
    } else {
      const resultsMonitor = this.getResultsMonitorDefaultData();

      resultsMonitor.selectMarket = this.$resultsMonitor.selectMarket;
      resultsMonitor.groupsOfProduct = this.$resultsMonitor.groupsOfProduct;
      resultsMonitor.categoriesOfProduct = this.$resultsMonitor.categoriesOfProduct;
      resultsMonitor.subcategories = this.$resultsMonitor.subcategories;
      resultsMonitor.formatSelected = this.$resultsMonitor.formatSelected;
      resultsMonitor.productSegments = this.$resultsMonitor.productSegments;

      this.$resultsMonitor = resultsMonitor;
    }
  }

  resetOmnichannelData(fullReset = true) {
    localStorage.removeItem('omnichannelStrategy');
  }

  resetRevaluationQueueData(fullReset = true) {
    localStorage.removeItem('revaluationQueueTrading');
  }

  resetRevaluationHistoryData(fullReset = true) {
    localStorage.removeItem('revaluationHistoryTrading');
  }

  resetPackageKviRecommendsData(fullReset = true) {
    localStorage.removeItem('packageKviRecommends');
    if (fullReset) {
      this.$packageKviRecommends = this.getPackageKviRecommendsDefaultData();
    } else {
      const packageKviRecommends = this.getPackageKviRecommendsDefaultData();
      packageKviRecommends.selectMarket = this.$packageKviRecommends.selectMarket;
      packageKviRecommends.categoriesOfProduct = this.$packageKviRecommends.categoriesOfProduct;
      packageKviRecommends.groupsOfProduct = this.$packageKviRecommends.groupsOfProduct;
      packageKviRecommends.subcategories = this.$packageKviRecommends.subcategories;
      packageKviRecommends.formatSelected = this.$packageKviRecommends.formatSelected;
      packageKviRecommends.regionSelected = this.$packageKviRecommends.regionSelected;
      packageKviRecommends.clusterSelected = this.$packageKviRecommends.clusterSelected;
      packageKviRecommends.seasonSelected = this.$packageKviRecommends.seasonSelected;
      this.$packageKviRecommends = packageKviRecommends;
    }
  }

  resetPackageParamsInDetailReportData(fullReset = true) {
    localStorage.removeItem('packageParamsInDetailReport');
    this.$packageParamsInDetailReport = this.getPackageParamsInDetailReportDefaultData();
  }

  resetPackagePromoData(fullReset = true) {
    localStorage.removeItem('packagePromo');
    if (fullReset) {
      this.$packagePromo = this.getPackagePromoDefaultData();
    } else {
      const packagePromo = this.getPackagePromoDefaultData();
      packagePromo.selectMarket = this.$packagePromo.selectMarket;
      packagePromo.categoriesOfProduct = this.$packagePromo.categoriesOfProduct;
      packagePromo.groupsOfProduct = this.$packagePromo.groupsOfProduct;
      packagePromo.subcategories = this.$packagePromo.subcategories;
      packagePromo.productSegments = this.$packagePromo.productSegments;
      packagePromo.formatSelected = this.$packagePromo.formatSelected;
      packagePromo.regionSelected = this.$packagePromo.regionSelected;
      packagePromo.clusterSelected = this.$packagePromo.clusterSelected;
      packagePromo.seasonSelected = this.$packagePromo.seasonSelected;
      this.$packagePromo = packagePromo;
    }
  }

  resetScheduleCalcData(fullReset = true) {
    localStorage.removeItem('scheduleCalc');
    if (fullReset) {
      this.$scheduleCalc = this.getPackageCalcDefaultData();
    } else {
      const scheduleCalc = this.getPackageCalcDefaultData();
      scheduleCalc.selectMarket = this.$packageCalc.selectMarket;
      scheduleCalc.categoriesOfProduct = this.$packageCalc.categoriesOfProduct;
      scheduleCalc.groupsOfProduct = this.$packageCalc.groupsOfProduct;
      scheduleCalc.subcategories = this.$packageCalc.subcategories;
      scheduleCalc.productSegments = this.$packageCalc.productSegments;
      scheduleCalc.formatSelected = this.$packageCalc.formatSelected;
      scheduleCalc.regionSelected = this.$packageCalc.regionSelected;
      scheduleCalc.clusterSelected = this.$packageCalc.clusterSelected;
      scheduleCalc.seasonSelected = this.$packageCalc.seasonSelected;
      this.$scheduleCalc = scheduleCalc;
    }
  }

  getCalcIndividConfig(config: ConfigMap<IndividualConfig>, sku: string, property: keyof IndividualConfig): number | SelectBox<any> | string | null | boolean | any[] {
    if (sku in config) {
      // tslint:disable-next-line: no-non-null-assertion
      return config[sku][property]!;
    }

    return null;
  }

// tslint:disable-next-line: max-line-length
  getPromoIndividConfig(config: ConfigMap<PromoIndividualConfig>, sku: string, property: keyof PromoIndividualConfig): number | null | StrategyOfPriceOpt | SelectBox<PromoType> | SelectBox<Coefficents> | SelectBox<number> | SelectBox<NewProductPriceStrategy> {
    if (sku in config) {
      // tslint:disable-next-line: no-non-null-assertion
      return config[sku][property]!;
    }
    return null;
  }

  setPromoIndividConfig(config: ConfigMap<PromoIndividualConfig>, sku: string, property: keyof PromoIndividualConfig, value: number | SelectBox<any>) {
    if (!(sku in config)) {
      config[sku] = {};
    }
    if (typeof value === 'number' && Number.isNaN(value)) {
      config[sku][property] = null;
    } else {
      config[sku][property] = value;
    }
  }

  setCalcIndividConfig(config: ConfigMap<IndividualConfig>, sku: string, property: keyof IndividualConfig, value: number | SelectBox<any> | string) {
    if (!(sku in config)) {
      config[sku] = {};
    }
    if (typeof value === 'number' && Number.isNaN(value)) {
      config[sku][property] = null;
    } else {
      config[sku][property] = value;
    }
  }

  // tslint:disable-next-line: max-line-length
  getIndividConfig(config: ConfigMap<PromoIndividualConfig>, sku: string, property: keyof PromoIndividualConfig): number | null | StrategyOfPriceOpt | SelectBox<PromoType> | SelectBox<Coefficents> | SelectBox<number> | SelectBox<NewProductPriceStrategy> {
    if (sku in config) {
      // tslint:disable-next-line: no-non-null-assertion
      return config[sku][property]!;
    }
    return null;
  }

  setIndividConfig(config: ConfigMap<PromoIndividualConfig>, sku: string, property: keyof PromoIndividualConfig, value: number | SelectBox<any>) {
    if (!(sku in config)) {
      config[sku] = {};
    }
    if (typeof value === 'number' && Number.isNaN(value)) {
      config[sku][property] = null;
    } else {
      config[sku][property] = value;
    }
  }

  getDefaultRevaluationCheckParams(): RevaluationCalculateParams {
    return {
      calculateByAllCompetitors: true,
      useRevaluationCalculate: false,
      purchasePriceDelta: 15,
      competitorsPriceDelta: 15,
      revaluationFrequencyCalculationDepth: 7,
      revaluationNumber: 1,
    }
  }

  getRoundingRulesDefaultData(): RoundingRules {
    return {
      pennies: true,
      allNewPricesWithoutPennies: true,
      categoryOfProduct: null,
      clusterSelected: null,
      formatSelected: null,
      regionSelected: [0],
      buyerSegmentsList: [],
      seasonSelected: [],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      groupOfProduct: null,
      subcategories: [],
      roundKviCompetitorPrice: false,
      categoryStrategy: categoryStrategiesSet.EMPTY,
      roundPricesWithEqualCompStrategy: true,
      randomPennies: false,
      manualPennies: 99,
      bigDigit: 1000,
      productSegments: [],
    }
  }

  getCalcDefaultData(): Calc {
    return {
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      selectCoefficent: {value: {k1: 1, k2: 0}, label: i18n.t('selectOptions.priceOptStrategy.maxGrossMargin') as string},
      individualCommonParams: {},
      allCheck: true,
      discountPrice: true,
      // pennies: true,
      countAtLastPurchasePrice: true,
      countAtFuturePurchasePrice: false,
      // allNewPricesWithoutPennies: true,
      allClaster: true,
      xyzChecked: true,
      uvwChecked: true,
      categoryOfProduct: null,
      clusterSelected: null,
      formatSelected: null,
      xyzParams: {x: 10, y: 20, z: 70},
      uvwParams: {u: 20, v: 30, w: 50},
      intervalOfUltimateElasticity: {lower: -3.5, upper: -0.5},
      taskInfo: {
        storeFormatOptions: [{value: null, label: i18n.t('selectOptions.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: i18n.t('selectOptions.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: i18n.t('selectOptions.common.selectCluster') as string}],
      },
      regionSelected: [0],
      buyerSegmentsList: [],
      seasonSelected: [],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      calculationDepth: 4,
      calculationDay: 28,
      competitorsPrices: 25,
      percentageOfCompetitorsPrice: '5',
      marginalProfitability: 5,
      marginalProfit: 5,
      maxMarginalProfit: 100,
      marginalPriceDifference: 10,
      newProductLifespanInDays: 10,
      priceIncreaseLimit: 15,
      priceDecreaseLimit: 15,
      kviPriceDecreaseLimit: 15,
      compPriceDecreaseLimit: 15,
      correlation: 0.7,
      highElasticity: -0.5,
      strategyCalcSelected: [
        {value: 2, label: i18n.t('selectOptions.kviStrategies.greaterThan') as string},
        {value: 3, label: i18n.t('selectOptions.kviStrategies.lessThan') as string},
        {value: 1, label: i18n.t('selectOptions.kviStrategies.equals') as string},
      ],
      kviStrategy: kviStrategiesSet.EQUALS,
      period: {value: 7, label: i18n.t('selectOptions.periods.week') as string},
      periodPriceIncreaseLimit: 100,
      priceCorridor: {
        min: 1.0,
        max: 100.0,
      },
      fixLowerBorder: true,
      depthToPurchasePrice: 4,
      priceFamilies: true,
      hardPriceFamilies: false,
      groupOfProduct: null,
      subcategories: [],
      changePriceCorridor: false,
      useCompetitorsPrices: false,
      byPromoPrices: false,
      competitorsPricePeriod: 28,
      competitorsPriceMethod: competitorsPriceMethodsSb.MIN_PRICE,
      competitorsCodes: [],
      competitorsPriceAdjustment: '10',
      competitorsInfluencesCoef: 1,
      competitorsMinimumProfit: 0,
      competitorsMaximumProfit: 100,
      competitorsControlParam: 10,
      competitorsPriceStrategy: competitorsPriceStrategiesSb.EQUALS,
      daysToPriceChangeStart: null,
      daysToPriceChangeFinish: null,
      // roundKviCompetitorPrice: false,
      calculateByElasticity: true,
      recalculateCtm: false,
      priceChangeLimit: 1,
      priceChangeLimitKvi: 1,
      priceChangeLimitComp: 1,
      calculatePYR: false,
      decreaseSalesCount: 5.0,
      newProductPriceStrategy: newProductPriceStrategySb.PENETRATION_STRATEGY,
      priceGap: 10.0,
      priceGapCtmPc: 10.0,
      ctmBrandPurpose: '0',
      categoryStrategy: categoryStrategiesSet.EMPTY,
      percentageOfRecommendsKviCount: 10,
      useSegmentsPriceInSearchKVIRecParam: false,
      saveKviSign: false,
      useCompetitorsForKviRecommends: false,
      competitorsPeriodForKviRecommends: 1,
      roundPricesWithEqualCompStrategy: true,
      calculateCompAllowedDeviation: true,
      useCompElasticity: false,
      minProfitKVI: 0,
      maxProfitKVI: 100,
      // randomPennies: false,
      // manualPennies: 99,
      forecastAccuracy: true,
      countAtMaxPurchasePrice: true,
      percentileType: percentileTypesSb.Q5,
      useAllProductBatchNumbers: false,
      competitorPriceControlParameterPc: 25,
      countPriceBySkuWithoutBatches: false,
      countByAvgPurchasePrice: false,
      calcPurchasePriceByClusters: false,
      useEmptyRemains: false,
      useArrivalDate: false,
      backBasketPart: 80.0,
      revaluationCalculateParams: this.getDefaultRevaluationCheckParams(),
      checkMarginDeclineProfit: false,
      declineProfitabilityPc: 25.0,
      searchPreviousPricesDepth: 7,
      thompsonSampling: false,
      hintsLoaded: false,
      currentModuleHints: [],
      compensateLowerTargets: false,
      inflation: true,
      calculateBySpeedSale: false,
      purchasePriceSuppliers: false,
      purchasePriceSuppliersWithRemains: false,
      categoryOfSuppliers: categoryOfSuppliersSb.ALL_SUPPLIERS,
      purchasePriceSuppliersMinProfit: 5,
      purchasePriceSuppliersMinProfitForKVI: 0,
      purchasePriceSuppliersMinProfitForCompetitors: 0,
      productSegments: [],
      isFixPricePromo: true,
      spreadByPriceSegments: true,
      priceExperiment: false,
      priceExperimentSampleSize: 50,
      priceExperimentDiscountRangeFrom: -10,
      priceExperimentDiscountRangeTo: 10,
      priceExperimentStep: 1,
      priceExperimentStartDate: null,
      priceExperimentEndDate: null,
      strategyValidityBeginDate: null,
      strategyValidityEndDate: null,
    };
  }

  getResultsDefaultData(): Results {
    return {
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      selectCoefficent: {value: {k1: 1, k2: 0}, label: i18n.t('selectOptions.priceOptStrategy.maxGrossMargin') as string},
      individualCommonParams: {},
      allCheck: true,
      discountPrice: true,
      // pennies: true,
      countAtLastPurchasePrice: true,
      countAtFuturePurchasePrice: false,
      // allNewPricesWithoutPennies: true,
      allClaster: true,
      xyzChecked: true,
      uvwChecked: true,
      categoryOfProduct: null,
      clusterSelected: null,
      formatSelected: null,
      xyzParams: {x: 10, y: 20, z: 70},
      uvwParams: {u: 20, v: 30, w: 50},
      intervalOfUltimateElasticity: {lower: -3.5, upper: -0.5},
      taskInfo: {
        storeFormatOptions: [{value: null, label: i18n.t('selectOptions.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: i18n.t('selectOptions.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: i18n.t('selectOptions.common.selectCluster') as string}],
      },
      regionSelected: [],
      buyerSegmentsList: [],
      seasonSelected: [],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      calculationDepth: 4,
      calculationDay: 28,
      competitorsPrices: 25,
      percentageOfCompetitorsPrice: '5',
      marginalProfitability: 5,
      marginalProfit: 5,
      maxMarginalProfit: 100,
      marginalPriceDifference: 10,
      newProductLifespanInDays: 10,
      priceIncreaseLimit: 15,
      priceDecreaseLimit: 15,
      kviPriceDecreaseLimit: 15,
      compPriceDecreaseLimit: 15,
      correlation: 0.7,
      highElasticity: -0.5,
      strategyCalcSelected: [
        {value: 2, label: i18n.t('selectOptions.kviStrategies.greaterThan') as string},
        {value: 3, label: i18n.t('selectOptions.kviStrategies.lessThan') as string},
        {value: 1, label: i18n.t('selectOptions.kviStrategies.equals') as string},
      ],
      kviStrategy: kviStrategiesSet.EQUALS,
      period: {value: 7, label: i18n.t('selectOptions.periods.week') as string},
      periodPriceIncreaseLimit: 100,
      priceCorridor: {
        min: 1.0,
        max: 100.0,
      },
      fixLowerBorder: true,
      depthToPurchasePrice: 4,
      priceFamilies: true,
      hardPriceFamilies: false,
      groupOfProduct: null,
      subcategories: [],
      changePriceCorridor: false,
      useCompetitorsPrices: false,
      byPromoPrices: false,
      competitorsPricePeriod: 28,
      competitorsPriceMethod: competitorsPriceMethodsSb.MIN_PRICE,
      competitorsCodes: [],
      competitorsPriceAdjustment: '10',
      competitorsInfluencesCoef: 1,
      competitorsMinimumProfit: 0,
      competitorsMaximumProfit: 100,
      competitorsControlParam: 10,
      competitorsPriceStrategy: competitorsPriceStrategiesSb.EQUALS,
      daysToPriceChangeStart: null,
      daysToPriceChangeFinish: null,
      // roundKviCompetitorPrice: false,
      calculateByElasticity: true,
      recalculateCtm: false,
      priceChangeLimit: 1,
      calculatePYR: false,
      decreaseSalesCount: 5.0,
      newProductPriceStrategy: newProductPriceStrategySb.PENETRATION_STRATEGY,
      priceGap: 10.0,
      priceGapCtmPc: 10.0,
      categoryStrategy: categoryStrategiesSet.EMPTY,
      percentageOfRecommendsKviCount: 10,
      useSegmentsPriceInSearchKVIRecParam: false,
      saveKviSign: false,
      useCompetitorsForKviRecommends: false,
      competitorsPeriodForKviRecommends: 1,
      roundPricesWithEqualCompStrategy: true,
      calculateCompAllowedDeviation: true,
      useCompElasticity: false,
      minProfitKVI: 0,
      maxProfitKVI: 100,
      // randomPennies: false,
      // manualPennies: 99,
      forecastAccuracy: true,
      countAtMaxPurchasePrice: true,
      percentileType: percentileTypesSb.Q5,
      useAllProductBatchNumbers: false,
      competitorPriceControlParameterPc: 25,
      countPriceBySkuWithoutBatches: false,
      countByAvgPurchasePrice: false,
      calcPurchasePriceByClusters: false,
      useEmptyRemains: false,
      useArrivalDate: false,
      backBasketPart: 80.0,
      revaluationCalculateParams: this.getDefaultRevaluationCheckParams(),
      checkMarginDeclineProfit: false,
      declineProfitabilityPc: 25.0,
      searchPreviousPricesDepth: 7,
      thompsonSampling: false,
      hintsLoaded: false,
      currentModuleHints: [],
      compensateLowerTargets: false,
      inflation: true,
      calculateBySpeedSale: false,
      purchasePriceSuppliers: false,
      purchasePriceSuppliersWithRemains: false,
      categoryOfSuppliers: categoryOfSuppliersSb.ALL_SUPPLIERS,
      purchasePriceSuppliersMinProfit: 5,
      purchasePriceSuppliersMinProfitForKVI: 0,
      purchasePriceSuppliersMinProfitForCompetitors: 0,
      productSegments: [],

    };
  }

  getPreCalcDefaultData(): PreCalc {
    return {
      preCalcId: -1,
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      groupOfProduct: null,
      categoryOfProduct: null,
      subcategories: [],
      productSegments: [],
      formatSelected: null,
      regionSelected: [],
      clusterSelected: null,
      buyerSegmentsList: [],
      seasonSelected: [],
      calculationDepth: 4,
      calculationDay: 28,
      depthToPurchasePrice: 4,
      countLastRegularPrice: true,
      countPriceSegment: true,
      countPurchasePrice: true,
      countCoeffElasticity: true,
      countAvgRegularPrice: true,
      countAvgCashPrice: true,
      countAvgCheckPrice: true,
      countMarginLastPrice: true,
      countActualSales: true,
      countActualRevenue: true,
      countActualMargin: true,
      countActualMarginPc: true,
      countComparableRevenue: true,
      countComparableMargin: true,
      countComparableMarginPc: true,
    };
  }

  getScenarioAnalysisDefaultData(): ScenarioAnalysisParams {
    return {
      selectCoefficent: {value: {k1: 1, k2: 0}, label: i18n.t('selectOptions.priceOptStrategy.maxGrossMargin') as string},
      allCheck: true,
      discountPrice: true,
      pennies: true,
      countAtFuturePurchasePrice: false,
      // allNewPricesWithoutPennies: true,
      allClaster: true,
      xyzChecked: true,
      uvwChecked: true,
      categoryOfProduct: null,
      clusterSelected: null,
      formatSelected: null,
      xyzParams: {x: 10, y: 20, z: 70},
      uvwParams: {u: 20, v: 30, w: 50},
      intervalOfUltimateElasticity: {lower: -3.5, upper: -0.5},
      taskInfo: {
        storeFormatOptions: [{value: null, label: i18n.t('selectOptions.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: i18n.t('selectOptions.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: i18n.t('selectOptions.common.selectCluster') as string}],
      },
      regionSelected: [],
      buyerSegmentsList: [],
      seasonSelected: [],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      calculationDepth: 4,
      calculationDay: 28,
      competitorsPrices: 25,
      percentageOfCompetitorsPrice: '5',
      marginalProfitability: 5,
      marginalProfit: 5,
      maxMarginalProfit: 100,
      marginalPriceDifference: 10,
      newProductLifespanInDays: 10,
      priceIncreaseLimit: 15,
      priceDecreaseLimit: 15,
      kviPriceDecreaseLimit: 15,
      compPriceDecreaseLimit: 15,
      correlation: 0.7,
      highElasticity: -0.5,
      kviStrategy: kviStrategiesSet.EQUALS,
      period: {value: 7, label: i18n.t('selectOptions.periods.week') as string},
      periodPriceIncreaseLimit: 100,
      priceCorridor: {
        min: 1.0,
        max: 100.0,
      },
      fixLowerBorder: true,
      depthToPurchasePrice: 4,
      priceFamilies: true,
      hardPriceFamilies: false,
      groupOfProduct: null,
      subcategories: [],
      changePriceCorridor: false,
      useCompetitorsPrices: false,
      byPromoPrices: false,
      competitorsPricePeriod: 28,
      competitorsPriceMethod: competitorsPriceMethodsSb.MIN_PRICE,
      competitorsPriceAdjustment: '10',
      competitorsInfluencesCoef: 1,
      competitorsMinimumProfit: 0,
      competitorsMaximumProfit: 100,
      competitorsControlParam: 10,
      competitorsPriceStrategy: competitorsPriceStrategiesSb.EQUALS,
      daysToPriceChangeStart: null,
      daysToPriceChangeFinish: null,
      roundKviCompetitorPrice: false,
      calculateByElasticity: true,
      recalculateCtm: false,
      priceChangeLimit: 1,
      priceChangeLimitKvi: 1,
      priceChangeLimitComp: 1,
      calculatePYR: false,
      newProductPriceStrategy: newProductPriceStrategySb.PENETRATION_STRATEGY,
      priceGap: 10.0,
      priceGapCtmPc: 10.0,
      categoryStrategy: categoryStrategiesSet.EMPTY,
      roundPricesWithEqualCompStrategy: true,
      calculateCompAllowedDeviation: true,
      useCompElasticity: false,
      minProfitKVI: 0,
      maxProfitKVI: 100,
      randomPennies: false,
      manualPennies: 99,
      forecastAccuracy: true,
      countAtMaxPurchasePrice: true,
      percentileType: percentileTypesSb.Q5,
      useAllProductBatchNumbers: false,
      competitorPriceControlParameterPc: 25,
      findAutomaticallyPriceSegments: false,
      countPriceSegments: 1,
      useEmptyRemains: false,
      useArrivalDate: false,
      backBasketPart: 80.0,
      revaluationCalculateParams: this.getDefaultRevaluationCheckParams(),
      checkMarginDeclineProfit: false,
      declineProfitabilityPc: 25.0,
      searchPreviousPricesDepth: 7,
      thompsonSampling: false,
      compensateLowerTargets: false,
      productSegments: [],
      decreaseSalesCount: 5.0,
      purchasePriceSuppliersMinProfit: 5,
      purchasePriceSuppliersMinProfitForKVI: 0,
      percentageOfRecommendsKviCount: 10,
      useSegmentsPriceInSearchKVIRecParam: false,
      saveKviSign: false,
      useCompetitorsForKviRecommends: false,
      competitorsPeriodForKviRecommends: 1,
      purchasePriceSuppliersMinProfitForCompetitors: 0,
      purchasePriceSuppliers: false,
      purchasePriceSuppliersWithRemains: false,
      categoryOfSuppliers: categoryOfSuppliersSb.ALL_SUPPLIERS,
      isFixPricePromo: false,
      useFixedPrices: true,
      spreadByPriceSegments: true,
    };
  }

  getPackageCalcDefaultData(): PackageCalc {
    return {
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      selectCoefficent: {value: {k1: 1, k2: 0}, label: i18n.t('selectOptions.priceOptStrategy.maxGrossMargin') as string},
      allCheck: true,
      discountPrice: true,
      pennies: true,
      allNewPricesWithoutPennies: true,
      allClaster: true,
      xyzChecked: true,
      uvwChecked: true,
      categoriesOfProduct: [],
      clusterSelected: [],
      formatSelected: [],
      xyzParams: {x: 10, y: 20, z: 70},
      uvwParams: {u: 20, v: 30, w: 50},
      intervalOfUltimateElasticity: {lower: -3.5, upper: -0.5},
      taskInfo: {
        storeFormatOptions: [{value: null, label: i18n.t('selectOptions.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: i18n.t('selectOptions.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: i18n.t('selectOptions.common.selectCluster') as string}],
      },
      regionSelected: [],
      buyerSegmentsList: [],
      seasonSelected: [],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      calculationDepth: 4,
      calculationDay: 28,
      competitorsPrices: 25,
      minProfitKVI: 0,
      maxProfitKVI: 100,
      percentageOfCompetitorsPrice: 5,
      marginalProfitability: 5,
      marginalProfit: 5,
      maxMarginalProfit: 100,
      marginalPriceDifference: 10,
      newProductLifespanInDays: 10,
      priceIncreaseLimit: 15,
      correlation: 0.7,
      highElasticity: -0.5,
      strategyCalcSelected: [
        {value: 2, label: i18n.t('selectOptions.kviStrategies.greaterThan') as string},
        {value: 3, label: i18n.t('selectOptions.kviStrategies.lessThan') as string},
        {value: 1, label: i18n.t('selectOptions.kviStrategies.equals') as string},
      ],
      kviStrategy: kviStrategiesSet.EQUALS,
      fixLowerBorder: false,
      depthToPurchasePrice: 4,
      priceFamilies: true,
      groupsOfProduct: [],
      subcategories: [],
      separateSubcategories: false,
      separateClusters: true,
      changePriceCorridor: false,
      useCompetitorsPrices: false,
      byPromoPrices: false,
      competitorsPricePeriod: 28,
      competitorsPriceMethod: competitorsPriceMethodsSb.MIN_PRICE,
      competitorsPriceAdjustment: '10',
      competitorsInfluencesCoef: 1,
      competitorsMinimumProfit: 0,
      competitorsMaximumProfit: 100,
      competitorsControlParam: 10,
      competitorsPriceStrategy: competitorsPriceStrategiesSb.EQUALS,
      daysToPriceChangeStart: null,
      daysToPriceChangeFinish: null,
      roundKviCompetitorPrice: false,
      calculateByRegression: true,
      recalculateCtm: false,
      categoryStrategy: categoryStrategiesSet.EMPTY,
      sendReportToFtp: false,
      makeGeneralReport: true,
      manualPennies: 99,
      backBasketPart: 80.0,
      compensateAllCategories: false,
      thompsonSampling: false,
      revaluationCalculateParams: this.getDefaultRevaluationCheckParams(),
      compensateLowerTargets: false,
      productSegments: [],
      applyOmnichannel: false,
      isFixPricePromo: false,
      useFixedPrices: true,
      selectKviCart: null,
      priceExperiment: false,
      priceExperimentSampleSize: 50,
      priceExperimentDiscountRangeFrom: -10,
      priceExperimentDiscountRangeTo: 10,
      priceExperimentStep: 1,
      priceExperimentStartDate: null,
      priceExperimentEndDate: null,
    };
  }
  getRevaluationDefaultData(): Revaluation {
    return {
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      categoriesOfProduct: [],
      clusterSelected: [],
      formatSelected: [],
      groupsOfProduct: [],
      subcategories: [],
      regionSelected: [],
      productSegments: [],
      seasonSelected: [],
      buyerSegmentsList: [],
    }
  }
  getEventsDefaultData(): Events {
    return {
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      categoriesOfProduct: [],
      allCheck: true,
      clusterSelected: [],
      groupsOfProduct: [],
      buyerSegmentsList: [],
      seasonSelected: [],
      regionSelected: [],
      formatSelected: [],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      subcategories: [],
      separateSubcategories: false,
      separateClusters: true,
      startCalculation: false,
      onlyChangedPrices: true,
      createCommonReport: false,
      deployPrices: false,
      periodicity: eventPeriodicityType.DAY,
      type: eventTypeLoadType.CHANGING_PURCHASE_PRICE,
      changingType: eventChangingTypeType.INCREASE,
      categoryStrategy: categoryStrategiesSet.EMPTY,
      timeout: 24,
      priority: 1,
      storeSegment: [],
      productSegments: [],
      applyOmnichannel: false,
      groupOfProduct: null,
      categoryOfProduct: null,
      singleFormat: null,
      singleRegion: null,
      selectKviCart: null,
    };
  }

  getResultsMonitorDefaultData(): ResultsMonitor {
    return {
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      categoriesOfProduct: [],
      allCheck: true,
      clusterSelected: [],
      groupsOfProduct: [],
      buyerSegmentsList: [],
      seasonSelected: [],
      regionSelected: [],
      formatSelected: [],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      subcategories: [],
      separateSubcategories: false,
      separateClusters: true,
      startCalculation: false,
      onlyChangedPrices: true,
      createCommonReport: false,
      deployPrices: false,
      periodicity: eventPeriodicityType.DAY,
      type: eventTypeLoadType.CHANGING_PURCHASE_PRICE,
      changingType: eventChangingTypeType.INCREASE,
      categoryStrategy: categoryStrategiesSet.EMPTY,
      timeout: 24,
      priority: 1,
      storeSegment: [],
      productSegments: [],
      applyOmnichannel: false,
      groupOfProduct: null,
      categoryOfProduct: null,
      singleFormat: null,
      singleRegion: null,
      selectKviCart: null,
    };
  }

  getPackageKviRecommendsDefaultData(): PackageKviRecommends {
    return {
      competitorsPeriodForKviRecommends: 1,
      minProfitKVI: 0,
      maxProfitKVI: 100,
      percentageOfRecommendsKviCount: 10,
      saveKviSign: false,
      useCompetitorsForKviRecommends: false,
      useSegmentsPriceInSearchKVIRecParam: false,
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      xyzChecked: true,
      uvwChecked: true,
      categoriesOfProduct: [],
      clusterSelected: [],
      formatSelected: [],
      xyzParams: {x: 10, y: 20, z: 70},
      uvwParams: {u: 20, v: 30, w: 50},
      intervalOfUltimateElasticity: {lower: -3.5, upper: -0.5},
      taskInfo: {
        storeFormatOptions: [{value: null, label: i18n.t('selectOptions.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: i18n.t('selectOptions.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: i18n.t('selectOptions.common.selectCluster') as string}],
      },
      regionSelected: [],
      buyerSegmentsList: [],
      seasonSelected: [],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      calculationDepth: 4,
      competitorsPrices: 25,
      percentageOfCompetitorsPrice: '5',
      kviStrategy: kviStrategiesSet.EQUALS,
      groupsOfProduct: [],
      subcategories: [],
      separateSubcategories: false,
      separateClusters: false,
      roundKviCompetitorPrice: false,
      categoryStrategy: categoryStrategiesSet.EMPTY,
      allCheck: true,
      discountPrice: true,
      allClaster: true,
      thompsonSampling: false,
      productSegments: [],
      isFixPricePromo: false,
    };
  }

  getPackageParamsInDetailReportDefaultData(): PackageParamsInDetailReport {
    return {
      availableStockDelta: 5,
      calculateCommon: false,
      crossCalculation: false,
      excludeOutOfStock: false,
      intervalOfCorrelationElasticity: {
        lower: -3.5,
        upper: -0.5,
      },
      lift: 0,
      promoType: {value: PromoType.PRICE, label: i18n.t('selectOptions.promoTypes.price') as string},
      useDiscountDurationForForecastCalculation: false,
      selectCoefficent: {value: {k1: 1, k2: 0}, label: i18n.t('selectOptions.priceOptStrategy.maxGrossMargin') as string},
      allCheck: true,
      discountPrice: true,
      pennies: true,
      countAtLastPurchasePrice: true,
      countAtFuturePurchasePrice: false,
      allNewPricesWithoutPennies: true,
      allClaster: true,
      xyzChecked: true,
      uvwChecked: true,
      xyzParams: {x: 10, y: 20, z: 70},
      uvwParams: {u: 20, v: 30, w: 50},
      intervalOfUltimateElasticity: {lower: -3.5, upper: -0.5},
      calculationDepth: 4,
      calculationDay: 28,
      competitorsPrices: 25,
      percentageOfCompetitorsPrice: '5',
      marginalProfitability: 5,
      marginalProfit: 5,
      maxMarginalProfit: 100,
      marginalPriceDifference: 10,
      newProductLifespanInDays: 10,
      priceIncreaseLimit: 15,
      priceDecreaseLimit: 15,
      kviPriceDecreaseLimit: 15,
      compPriceDecreaseLimit: 15,
      correlation: 0.7,
      highElasticity: -0.5,
      kviStrategy: kviStrategiesSet.EQUALS,
      period: {value: 7, label: i18n.t('selectOptions.periods.week') as string},
      periodPriceIncreaseLimit: 100,
      priceCorridor: {
        min: 1.0,
        max: 100.0,
      },
      fixLowerBorder: true,
      depthToPurchasePrice: 4,
      priceFamilies: true,
      hardPriceFamilies: false,
      changePriceCorridor: false,
      useCompetitorsPrices: false,
      byPromoPrices: false,
      competitorsPricePeriod: 28,
      competitorsPriceMethod: competitorsPriceMethodsSb.MIN_PRICE,
      competitorsPriceAdjustment: '10',
      competitorsInfluencesCoef: 1,
      competitorsMinimumProfit: 0,
      competitorsMaximumProfit: 100,
      competitorsControlParam: 10,
      competitorsPriceStrategy: competitorsPriceStrategiesSb.EQUALS,
      daysToPriceChangeStart: null,
      daysToPriceChangeFinish: null,
      roundKviCompetitorPrice: false,
      calculateByElasticity: true,
      recalculateCtm: false,
      priceChangeLimit: 1,
      calculatePYR: false,
      newProductPriceStrategy: newProductPriceStrategySb.PENETRATION_STRATEGY,
      priceGap: 10.0,
      priceGapCtmPc: 10.0,
      roundPricesWithEqualCompStrategy: true,
      calculateCompAllowedDeviation: true,
      useCompElasticity: false,
      minProfitKVI: 0,
      maxProfitKVI: 100,
      randomPennies: false,
      countPriceBySkuWithoutBatches: false,
      countByAvgPurchasePrice: false,
      calcPurchasePriceByClusters: false,
      manualPennies: 99,
      forecastAccuracy: true,
      countAtMaxPurchasePrice: true,
      useAllProductBatchNumbers: false,
      useEmptyRemains: false,
      useArrivalDate: false,
      backBasketPart: 80.0,
      percentileType: percentileTypesSb.Q5,
      revaluationCalculateParams: this.getDefaultRevaluationCheckParams(),
      checkMarginDeclineProfit: false,
      declineProfitabilityPc: 25.0,
      searchPreviousPricesDepth: 7,
      compensateLowerTargets: false,
      spreadByPriceSegments: true,
    };
  }

  getPackagePromoDefaultData(): PackagePromo {
    return {
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      selectCoefficent: {value: {k1: 1, k2: 0}, label: i18n.t('selectOptions.priceOptStrategy.maxGrossMargin') as string},
      allCheck: true,
      discountPrice: true,
      pennies: true,
      allNewPricesWithoutPennies: true,
      allClaster: true,
      xyzChecked: true,
      uvwChecked: true,
      categoriesOfProduct: [],
      clusterSelected: [],
      formatSelected: [],
      xyzParams: {x: 10, y: 20, z: 70},
      uvwParams: {u: 20, v: 30, w: 50},
      intervalOfUltimateElasticity: {lower: -3.5, upper: -0.5},
      taskInfo: {
        storeFormatOptions: [{value: null, label: i18n.t('selectOptions.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: i18n.t('selectOptions.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: i18n.t('selectOptions.common.selectCluster') as string}],
      },
      regionSelected: [],
      buyerSegmentsList: [],
      seasonSelected: [],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      calculationDepth: 4,
      calculationDay: 28,
      competitorsPrices: 25,
      minProfitKVI: 0,
      maxProfitKVI: 100,
      percentageOfCompetitorsPrice: 5,
      marginalProfitability: 5,
      marginalProfit: 5,
      maxMarginalProfit: 100,
      marginalPriceDifference: 10,
      newProductLifespanInDays: 10,
      priceIncreaseLimit: 15,
      correlation: 0.7,
      highElasticity: -0.5,
      strategyCalcSelected: [
        {value: 2, label: i18n.t('selectOptions.kviStrategies.greaterThan') as string},
        {value: 3, label: i18n.t('selectOptions.kviStrategies.lessThan') as string},
        {value: 1, label: i18n.t('selectOptions.kviStrategies.equals') as string},
      ],
      kviStrategy: kviStrategiesSet.EQUALS,
      fixLowerBorder: false,
      depthToPurchasePrice: 4,
      priceFamilies: true,
      groupsOfProduct: [],
      subcategories: [],
      separateSubcategories: false,
      separateClusters: true,
      changePriceCorridor: false,
      useCompetitorsPrices: false,
      byPromoPrices: false,
      competitorsPricePeriod: 28,
      competitorsPriceMethod: competitorsPriceMethodsSb.MIN_PRICE,
      competitorsPriceAdjustment: '10',
      competitorsInfluencesCoef: 1,
      competitorsMinimumProfit: 0,
      competitorsMaximumProfit: 100,
      competitorsControlParam: 10,
      competitorsPriceStrategy: competitorsPriceStrategiesSb.EQUALS,
      daysToPriceChangeStart: null,
      daysToPriceChangeFinish: null,
      roundKviCompetitorPrice: false,
      calculateByRegression: true,
      recalculateCtm: false,
      categoryStrategy: categoryStrategiesSet.EMPTY,
      sendReportToFtp: false,
      makeGeneralReport: true,
      manualPennies: 99,
      thompsonSampling: false,
      revaluationCalculateParams: this.getDefaultRevaluationCheckParams(),
      compensateLowerTargets: false,
      productSegments: [],
      applyOmnichannel: false,
      isFixPricePromo: false,
      useFixedPrices: true,
      selectKviCart: null,
      priceExperiment: false,
      priceExperimentSampleSize: 50,
      priceExperimentDiscountRangeFrom: -10,
      priceExperimentDiscountRangeTo: 10,
      priceExperimentStep: 1,
    };
  }

  getKviShoppingCartDefaultData(): KviShoppingCart {
    return {
      separateClusters: false,
      selectKviCart: {id: -1, kviCartName: i18n.t('selectOptions.common.select') as string},
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      selectCoefficent: {value: {k1: 1, k2: 0}, label: i18n.t('selectOptions.priceOptStrategy.maxGrossMargin') as string},
      individualCommonParams: {},
      allCheck: true,
      discountPrice: true,
      pennies: true,
      countAtLastPurchasePrice: true,
      countAtFuturePurchasePrice: false,
      allNewPricesWithoutPennies: true,
      allClaster: true,
      xyzChecked: true,
      uvwChecked: true,
      categoryOfProduct: null,
      clusterSelected: [],
      formatSelected: null,
      groupsOfProduct: [],
      categories: [],
      xyzParams: {x: 10, y: 20, z: 70},
      uvwParams: {u: 20, v: 30, w: 50},
      intervalOfUltimateElasticity: {lower: -3.5, upper: -0.5},
      taskInfo: {
        storeFormatOptions: [{value: null, label: i18n.t('selectOptions.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: i18n.t('selectOptions.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: i18n.t('selectOptions.common.selectCluster') as string}],
      },
      subcategory: null,
      segment: null,
      regionSelected: [],
      buyerSegmentsList: [],
      seasonSelected: [],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      calculationDepth: 4,
      calculationDay: 28,
      competitorsPrices: 25,
      percentageOfCompetitorsPrice: '5',
      marginalProfitability: 5,
      marginalProfit: 5,
      maxMarginalProfit: 100,
      marginalPriceDifference: 10,
      newProductLifespanInDays: 10,
      priceIncreaseLimit: 15,
      correlation: 0.7,
      highElasticity: -0.5,
      strategyCalcSelected: [
        {value: 2, label: i18n.t('selectOptions.kviStrategies.greaterThan') as string},
        {value: 3, label: i18n.t('selectOptions.kviStrategies.lessThan') as string},
        {value: 1, label: i18n.t('selectOptions.kviStrategies.equals') as string},
      ],
      kviStrategy: kviStrategiesSet.EQUALS,
      period: {value: 7, label: i18n.t('selectOptions.periods.week') as string},
      periodPriceIncreaseLimit: 100,
      priceCorridor: {
        min: 1.0,
        max: 100.0,
      },
      fixLowerBorder: true,
      depthToPurchasePrice: 4,
      priceFamilies: true,
      hardPriceFamilies: false,
      groupOfProduct: null,
      subcategories: [],
      productSegments: [],
      changePriceCorridor: false,
      useCompetitorsPrices: false,
      byPromoPrices: false,
      competitorsPricePeriod: 28,
      competitorsPriceMethod: competitorsPriceMethodsSb.MIN_PRICE,
      competitorsCodes: [],
      competitorsPriceAdjustment: '10',
      competitorsInfluencesCoef: 1,
      competitorsMinimumProfit: 0,
      competitorsMaximumProfit: 100,
      competitorsControlParam: 10,
      competitorsPriceStrategy: competitorsPriceStrategiesSb.EQUALS,
      daysToPriceChangeStart: null,
      daysToPriceChangeFinish: null,
      roundKviCompetitorPrice: false,
      calculateByElasticity: true,
      recalculateCtm: false,
      priceChangeLimit: 1,
      priceChangeLimitKvi: 1,
      priceChangeLimitComp: 1,
      calculatePYR: false,
      decreaseSalesCount: 5.0,
      newProductPriceStrategy: newProductPriceStrategySb.PENETRATION_STRATEGY,
      priceGap: 10.0,
      priceGapCtmPc: 10.0,
      categoryStrategy: categoryStrategiesSet.EMPTY,
      percentageOfRecommendsKviCount: 10,
      useSegmentsPriceInSearchKVIRecParam: false,
      saveKviSign: false,
      useCompetitorsForKviRecommends: false,
      competitorsPeriodForKviRecommends: 1,
      roundPricesWithEqualCompStrategy: true,
      calculateCompAllowedDeviation: true,
      useCompElasticity: false,
      minProfitKVI: 0,
      maxProfitKVI: 100,
      randomPennies: false,
      kviCartChangePrices: kviCartChangePricesSb.ALL_CART_PRICES,
      manualPennies: 99,
      downloadParamsWithSubcategory: false,
      percentileType: percentileTypesSb.Q5,
      competitorPriceControlParameterPc: 25,
      revaluationCalculateParams: this.getDefaultRevaluationCheckParams(),
      checkMarginDeclineProfit: false,
      declineProfitabilityPc: 25.0,
      searchPreviousPricesDepth: 7,
      thompsonSampling: false,
      downloadParamsWithCategory: true,
      isFixPricePromo: false,
    };
  }

  getPackagePromoRecommendsDefaultData()
      :
      PackagePromoRecommends {
    return {
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      categoriesOfProduct: [],
      clusterSelected: [],
      seasonSelected: [],
      buyerSegmentsList: [],
      regionSelected: [],
      formatSelected: [],
      groupsOfProduct: [],
      subcategories: [],
      separateSubcategories: false,
      separateClusters: true,
      categoryStrategy: categoryStrategiesSet.EMPTY,
      taskInfo: {
        storeFormatOptions: [{value: null, label: i18n.t('selectOptions.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: i18n.t('selectOptions.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: i18n.t('selectOptions.common.selectCluster') as string}],
      },
      calculationDepth: 8,
      calculationDay: 28,
      manualPennies: 99,
      productSegments: [],
      isFixPricePromo: false,
    };
  }

  toYesOrNo(value: boolean | null): string | null {
    if (value == null) {
      return value
    }

    if (value) {
      return i18n.t('shared.boolFilter.yes') as string
    } else {
      return i18n.t('shared.boolFilter.no') as string
    }
  }

  getPromoDefaultData(): Promo {
    return {
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      selectCoefficent: {value: {k1: 1, k2: 0}, label: i18n.t('selectOptions.priceOptStrategy.maxGrossMargin') as string},
      individualCommonParams: {},
      allCheck: true,
      discountPrice: true,
      // pennies: true,
      countAtLastPurchasePrice: true,
      countAtFuturePurchasePrice: false,
      // allNewPricesWithoutPennies: true,
      allClaster: true,
      calcRecommendsWithPriceSegments: true,
      xyzChecked: true,
      uvwChecked: true,
      categoryOfProduct: null,
      clusterSelected: null,
      formatSelected: null,
      xyzParams: {x: 10, y: 20, z: 70},
      uvwParams: {u: 20, v: 30, w: 50},
      intervalOfUltimateElasticity: {lower: -3.5, upper: -0.5},
      taskInfo: {
        storeFormatOptions: [{value: null, label: i18n.t('selectOptions.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: i18n.t('selectOptions.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: i18n.t('selectOptions.common.selectCluster') as string}],
      },
      regionSelected: [0],
      buyerSegmentsList: [],
      seasonSelected: [],
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      calculationDepth: 8,
      promoPriceCalculationDepth: 8,
      calculationDay: 28,
      competitorsPrices: 25,
      percentageOfCompetitorsPrice: '5',
      marginalProfitability: 5,
      marginalProfit: 5,
      maxMarginalProfit: 100,
      marginalPriceDifference: 10,
      newProductLifespanInDays: 10,
      priceIncreaseLimit: 15,
      correlation: 0.7,
      highElasticity: -0.5,
      strategyCalcSelected: [
        {value: 2, label: i18n.t('selectOptions.kviStrategies.greaterThan') as string},
        {value: 3, label: i18n.t('selectOptions.kviStrategies.lessThan') as string},
        {value: 1, label: i18n.t('selectOptions.kviStrategies.equals') as string},
      ],
      kviStrategy: kviStrategiesSet.EQUALS,
      period: {value: 7, label: i18n.t('selectOptions.periods.week') as string},
      periodPriceIncreaseLimit: 100,
      priceCorridor: {
        min: 1.0,
        max: 100.0,
      },
      fixLowerBorder: true,
      depthToPurchasePrice: 8,
      priceFamilies: true,
      hardPriceFamilies: false,
      groupOfProduct: null,
      subcategories: [],
      changePriceCorridor: false,
      useCompetitorsPrices: false,
      byPromoPrices: false,
      competitorsPricePeriod: 28,
      competitorsPriceMethod: competitorsPriceMethodsSb.MIN_PRICE,
      competitorsCodes: [],
      competitorsPriceAdjustment: '10',
      competitorsInfluencesCoef: 1,
      competitorsMinimumProfit: 0,
      competitorsMaximumProfit: 100,
      competitorsControlParam: 10,
      competitorsPriceStrategy: competitorsPriceStrategiesSb.EQUALS,
      daysToPriceChangeStart: null,
      daysToPriceChangeFinish: null,
      // roundKviCompetitorPrice: false,
      calculateByElasticity: true,
      recalculateCtm: false,
      selectedSkuList: [],
      lift: 1,
      crossCalculation: false,
      promoType: {value: PromoType.PRICE, label: i18n.t('selectOptions.promoTypes.price') as string},
      purchasePrice: null,
      individualPromoConfig: {},
      availableStockDelta: 5,
      calculateCommon: false,
      intervalOfCorrelationElasticity: {
        lower: -3.5,
        upper: -0.5,
      },
      priceChangeLimit: 1,
      priceChangeLimitKvi: 1,
      priceChangeLimitComp: 1,
      calculatePYR: false,
      newProductPriceStrategy: newProductPriceStrategySb.PENETRATION_STRATEGY,
      priceGap: 10.0,
      priceGapCtmPc: 10.0,
      ctmBrandPurpose: '0',
      categoryStrategy: categoryStrategiesSet.EMPTY,
      useDiscountDurationForForecastCalculation: true,
      useProductRange: false,
      useSkuRotation: false,
      percentageOfRecommendsKviCount: 10,
      useSegmentsPriceInSearchKVIRecParam: false,
      saveKviSign: false,
      useCompetitorsForKviRecommends: false,
      competitorsPeriodForKviRecommends: 1,
      roundPricesWithEqualCompStrategy: true,
      calculateCompAllowedDeviation: true,
      useCompElasticity: false,
      minProfitKVI: 0,
      maxProfitKVI: 100,
      // randomPennies: false,
      excludeOutOfStock: false,
      // manualPennies: 99,
      forecastAccuracy: true,
      percentileType: percentileTypesSb.Q5,
      competitorPriceControlParameterPc: 50,
      revaluationCalculateParams: {
        calculateByAllCompetitors: true,
        useRevaluationCalculate: false,
        purchasePriceDelta: 15,
        competitorsPriceDelta: 15,
        revaluationFrequencyCalculationDepth: 7,
        revaluationNumber: 1,
      },
      thompsonSampling: false,
      hintsLoaded: false,
      currentModuleHints: [],
      inflation: true,
      calculateBySpeedSale: false,
      productSegments: [],
      isFixPricePromo: false,
      spreadByPriceSegments: true,
      rotationPeriodType: {value: SkuRotationPeriodType.MONTH, label: i18n.t('selectOptions.periods.month') as string},
      usePromoQuote: false,
      promoQuoteValue: null,
      useCompetitorsPromoPrices: false,
      calculateCompAllowedDeviationPromo: true,
      competitorPriceControlParameterPcPromo: 50,
      competitorsPricePeriodPromo: 28,
      competitorsPromoPriceInfluencesCoef: 1,
      percentileTypePromo: {value: PercentileTypes.Q5, label: '0-100'},
      competitorsPromoPriceAdjustment: '10',
      competitorsControlPromoParam: 10,
      competitorsPromoPriceMethod: competitorsPromoPriceMethodsSb.MIN_PRICE,
      competitorsMinimumProfitPromo: 0,
      competitorsMaximumProfitPromo: 100,
      competitorsPromoPriceStrategy: competitorsPromoPriceStrategiesSb.EQUALS,
      planningPromoPeriodStartDate: '',
      planningPromoPeriodEndDate: '',
      minDefaultDiscount: 15,
      maxDefaultDiscount: 50,
      priceExperiment: false,
      priceExperimentSampleSize: 50,
      priceExperimentDiscountRangeFrom: -10,
      priceExperimentDiscountRangeTo: 10,
      priceExperimentStep: 1,
    };
  }

  getSalesDefaultData(): Sales {
    return {
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      considerPlannedSeason: false,
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      selectCoefficent: {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: i18n.t('selectOptions.priceOptStrategy.maxGrossMargin') as string},
      individualCommonParams: {},
      allCheck: true,
      discountPrice: true,
      // pennies: true,
      countAtLastPurchasePrice: true,
      countAtFuturePurchasePrice: false,
      // allNewPricesWithoutPennies: true,
      allClaster: true,
      calcRecommendsWithPriceSegments: true,
      xyzChecked: true,
      uvwChecked: true,
      categoryIds: [],
      clusterIds: [],
      formatSelected: null,
      xyzParams: {x: 10, y: 20, z: 70},
      uvwParams: {u: 20, v: 30, w: 50},
      intervalOfUltimateElasticity: {lower: -3.5, upper: -0.5},
      taskInfo: {
        storeFormatOptions: [{value: null, label: i18n.t('selectOptions.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: i18n.t('selectOptions.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: i18n.t('selectOptions.common.selectCluster') as string}],
      },
      regionIds: [],
      buyerSegmentsList: [],
      seasonSelected: [],

      calculationDepth: 8,
      promoPriceCalculationDepth: 8,
      calculationDay: 28,
      competitorsPrices: 25,
      percentageOfCompetitorsPrice: '5',
      marginalProfitability: 5,
      marginalProfit: 5,
      maxMarginalProfit: 100,
      marginalPriceDifference: 10,
      newProductLifespanInDays: 10,
      priceIncreaseLimit: 15,
      correlation: 0.7,
      highElasticity: -0.5,
      strategyCalcSelected: [
        {value: 2, label: i18n.t('selectOptions.kviStrategies.greaterThan') as string},
        {value: 3, label: i18n.t('selectOptions.kviStrategies.lessThan') as string},
        {value: 1, label: i18n.t('selectOptions.kviStrategies.equals') as string},
      ],
      kviStrategy: kviStrategiesSet.EQUALS,
      period: {value: 7, label: i18n.t('selectOptions.periods.week') as string},
      periodPriceIncreaseLimit: 100,
      priceCorridor: {
        min: 1.0,
        max: 100.0,
      },
      fixLowerBorder: true,
      depthToPurchasePrice: 8,
      priceFamilies: true,
      hardPriceFamilies: false,
      groupIds: [],
      subcategories: [],
      changePriceCorridor: false,
      useCompetitorsPrices: false,
      byPromoPrices: false,
      competitorsPricePeriod: 28,
      competitorsPriceMethod: competitorsPriceMethodsSb.MIN_PRICE,
      competitorsCodes: [],
      competitorsPriceAdjustment: '10',
      competitorsInfluencesCoef: 1,
      competitorsMinimumProfit: 0,
      competitorsMaximumProfit: 100,
      competitorsControlParam: 10,
      competitorsPriceStrategy: competitorsPriceStrategiesSb.EQUALS,
      daysToPriceChangeStart: null,
      daysToPriceChangeFinish: null,
      // roundKviCompetitorPrice: false,
      calculateByElasticity: true,
      recalculateCtm: false,
      selectedSkuList: [],
      lift: 1,
      crossCalculation: false,
      promoType: {value: PromoType.PRICE, label: i18n.t('selectOptions.promoTypes.price') as string},
      purchasePrice: null,
      individualSaleConfig: {},
      individualConfig: {},
      availableStockDelta: 5,
      calculateCommon: false,
      intervalOfCorrelationElasticity: {
        lower: -3.5,
        upper: -0.5,
      },
      priceChangeLimit: 1,
      priceChangeLimitKvi: 1,
      priceChangeLimitComp: 1,
      calculatePYR: false,
      newProductPriceStrategy: newProductPriceStrategySb.PENETRATION_STRATEGY,
      priceGap: 10.0,
      priceGapCtmPc: 10.0,
      ctmBrandPurpose: '0',
      categoryStrategy: categoryStrategiesSet.EMPTY,
      useDiscountDurationForForecastCalculation: true,
      useProductRange: false,
      useSkuRotation: false,
      percentageOfRecommendsKviCount: 10,
      useSegmentsPriceInSearchKVIRecParam: false,
      saveKviSign: false,
      useCompetitorsForKviRecommends: false,
      competitorsPeriodForKviRecommends: 1,
      roundPricesWithEqualCompStrategy: true,
      calculateCompAllowedDeviation: true,
      useCompElasticity: false,
      minProfitKVI: 0,
      maxProfitKVI: 100,
      // randomPennies: false,
      excludeOutOfStock: false,
      calculateBySalePoints: false,
      calculateBySubcategories: false,
      trainModel: false,
      autoCreateSchedule: false,
      // manualPennies: 99,
      forecastAccuracy: true,
      percentileType: percentileTypesSb.Q5,
      competitorPriceControlParameterPc: 50,
      revaluationCalculateParams: {
        calculateByAllCompetitors: true,
        useRevaluationCalculate: false,
        purchasePriceDelta: 15,
        competitorsPriceDelta: 15,
        revaluationFrequencyCalculationDepth: 7,
        revaluationNumber: 1,
      },
      thompsonSampling: false,
      hintsLoaded: false,
      currentModuleHints: [],
      inflation: true,
      calculateBySpeedSale: false,
      productSegments: [],
      isFixPricePromo: false,
      rotationPeriodType: SkuRotationPeriodType.MONTH,
      usePromoQuote: false,
      promoQuoteValue: null,
      useCompetitorsPromoPrices: false,
      calculateCompAllowedDeviationPromo: true,
      competitorPriceControlParameterPcPromo: 50,
      competitorsPricePeriodPromo: 28,
      competitorsPromoPriceInfluencesCoef: 1,
      percentileTypePromo: PercentileTypes.Q5,
      competitorsPromoPriceAdjustment: '10',
      competitorsControlPromoParam: 10,
      competitorsPromoPriceMethod: competitorsPromoPriceMethodsSb.MIN_PRICE,
      competitorsMinimumProfitPromo: 0,
      competitorsMaximumProfitPromo: 100,
      competitorsPromoPriceStrategy: competitorsPromoPriceStrategiesSb.EQUALS,
      planningPromoPeriodStartDate: '',
      planningPromoPeriodEndDate: '',

      // from Calc

      priceDecreaseLimit: 15,
      kviPriceDecreaseLimit: 15,
      compPriceDecreaseLimit: 15,
      decreaseSalesCount: 5.0,

      // randomPennies: false,
      // manualPennies: 99,
      countAtMaxPurchasePrice: true,
      useAllProductBatchNumbers: false,
      countPriceBySkuWithoutBatches: false,
      countByAvgPurchasePrice: false,
      calcPurchasePriceByClusters: false,
      useEmptyRemains: false,
      useArrivalDate: false,
      backBasketPart: 80.0,
      checkMarginDeclineProfit: false,
      declineProfitabilityPc: 25.0,
      searchPreviousPricesDepth: 7,
      compensateLowerTargets: false,
      purchasePriceSuppliers: false,
      purchasePriceSuppliersWithRemains: false,
      categoryOfSuppliers: categoryOfSuppliersSb.ALL_SUPPLIERS,
      purchasePriceSuppliersMinProfit: 5,
      purchasePriceSuppliersMinProfitForKVI: 0,
      purchasePriceSuppliersMinProfitForCompetitors: 0,
      spreadByPriceSegments: true,
    };
  }

  getPromotionsDefaultData(): Promotions {
    return {
      selectMarket: {id: -1, tradingName: i18n.t('selectOptions.common.select') as string, isDefault: false},
      considerPlannedSeason: false,
      defaultSelectValue: [{value: 0, label: i18n.t('selectOptions.common.all') as string}],
      selectCoefficent: {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: i18n.t('selectOptions.priceOptStrategy.maxGrossMargin') as string},
      calculationType: { value: 'standard', label: i18n.t('selectOptions.calculationType.standard') as string },
      individualCommonParams: {},
      allCheck: true,
      discountPrice: true,
      // pennies: true,
      countAtLastPurchasePrice: true,
      countAtFuturePurchasePrice: false,
      // allNewPricesWithoutPennies: true,
      allClaster: true,
      calcRecommendsWithPriceSegments: true,
      xyzChecked: true,
      uvwChecked: true,
      categoryIds: [],
      clusterIds: [],
      formatSelected: null,
      xyzParams: {x: 10, y: 20, z: 70},
      uvwParams: {u: 20, v: 30, w: 50},
      intervalOfUltimateElasticity: {lower: -3.5, upper: -0.5},
      taskInfo: {
        storeFormatOptions: [{value: null, label: i18n.t('selectOptions.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: i18n.t('selectOptions.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: i18n.t('selectOptions.common.selectCluster') as string}],
      },
      regionIds: [],
      buyerSegmentsList: [],
      seasonSelected: [],

      calculationDepth: 8,
      promoPriceCalculationDepth: 8,
      calculationDay: 28,
      competitorsPrices: 25,
      percentageOfCompetitorsPrice: '5',
      marginalProfitability: 5,
      marginalProfit: 5,
      maxMarginalProfit: 100,
      marginalPriceDifference: 10,
      newProductLifespanInDays: 10,
      priceIncreaseLimit: 15,
      correlation: 0.7,
      highElasticity: -0.5,
      strategyCalcSelected: [
        {value: 2, label: i18n.t('selectOptions.kviStrategies.greaterThan') as string},
        {value: 3, label: i18n.t('selectOptions.kviStrategies.lessThan') as string},
        {value: 1, label: i18n.t('selectOptions.kviStrategies.equals') as string},
      ],
      kviStrategy: kviStrategiesSet.EQUALS,
      period: {value: 7, label: i18n.t('selectOptions.periods.week') as string},
      periodPriceIncreaseLimit: 100,
      priceCorridor: {
        min: 1.0,
        max: 100.0,
      },
      fixLowerBorder: true,
      depthToPurchasePrice: 8,
      priceFamilies: true,
      hardPriceFamilies: false,
      groupIds: [],
      subcategories: [],
      changePriceCorridor: false,
      useCompetitorsPrices: false,
      byPromoPrices: false,
      competitorsPricePeriod: 28,
      competitorsPriceMethod: competitorsPriceMethodsSb.MIN_PRICE,
      competitorsCodes: [],
      competitorsPriceAdjustment: '10',
      competitorsInfluencesCoef: 1,
      competitorsMinimumProfit: 0,
      competitorsMaximumProfit: 100,
      competitorsControlParam: 10,
      competitorsPriceStrategy: competitorsPriceStrategiesSb.EQUALS,
      daysToPriceChangeStart: null,
      daysToPriceChangeFinish: null,
      // roundKviCompetitorPrice: false,
      calculateByElasticity: true,
      recalculateCtm: false,
      selectedSkuList: [],
      lift: 1,
      crossCalculation: false,
      promoType: {value: PromoType.PRICE, label: i18n.t('selectOptions.promoTypes.price') as string},
      purchasePrice: null,
      individualSaleConfig: {},
      individualConfig: {},
      availableStockDelta: 5,
      calculateCommon: false,
      intervalOfCorrelationElasticity: {
        lower: -3.5,
        upper: -0.5,
      },
      priceChangeLimit: 1,
      priceChangeLimitKvi: 1,
      priceChangeLimitComp: 1,
      calculatePYR: false,
      newProductPriceStrategy: newProductPriceStrategySb.PENETRATION_STRATEGY,
      priceGap: 10.0,
      priceGapCtmPc: 10.0,
      ctmBrandPurpose: '0',
      categoryStrategy: categoryStrategiesSet.EMPTY,
      useDiscountDurationForForecastCalculation: true,
      useProductRange: false,
      useSkuRotation: false,
      percentageOfRecommendsKviCount: 10,
      useSegmentsPriceInSearchKVIRecParam: false,
      saveKviSign: false,
      useCompetitorsForKviRecommends: false,
      competitorsPeriodForKviRecommends: 1,
      roundPricesWithEqualCompStrategy: true,
      calculateCompAllowedDeviation: true,
      useCompElasticity: false,
      minProfitKVI: 0,
      maxProfitKVI: 100,
      // randomPennies: false,
      excludeOutOfStock: false,
      calculateBySalePoints: false,
      trainModel: false,
      considerCannibalization: false,
      // manualPennies: 99,
      forecastAccuracy: true,
      percentileType: percentileTypesSb.Q5,
      competitorPriceControlParameterPc: 50,
      revaluationCalculateParams: {
        calculateByAllCompetitors: true,
        useRevaluationCalculate: false,
        purchasePriceDelta: 15,
        competitorsPriceDelta: 15,
        revaluationFrequencyCalculationDepth: 7,
        revaluationNumber: 1,
      },
      thompsonSampling: false,
      hintsLoaded: false,
      currentModuleHints: [],
      inflation: true,
      calculateBySpeedSale: false,
      productSegments: [],
      isFixPricePromo: false,
      rotationPeriodType: SkuRotationPeriodType.MONTH,
      usePromoQuote: false,
      promoQuoteValue: null,
      useCompetitorsPromoPrices: false,
      calculateCompAllowedDeviationPromo: true,
      competitorPriceControlParameterPcPromo: 50,
      competitorsPricePeriodPromo: 28,
      competitorsPromoPriceInfluencesCoef: 1,
      percentileTypePromo: PercentileTypes.Q5,
      competitorsPromoPriceAdjustment: '10',
      competitorsControlPromoParam: 10,
      competitorsPromoPriceMethod: competitorsPromoPriceMethodsSb.MIN_PRICE,
      competitorsMinimumProfitPromo: 0,
      competitorsMaximumProfitPromo: 100,
      competitorsPromoPriceStrategy: competitorsPromoPriceStrategiesSb.EQUALS,
      planningPromoPeriodStartDate: '',
      planningPromoPeriodEndDate: '',

      // from Calc
      priceDecreaseLimit: 15,
      kviPriceDecreaseLimit: 15,
      compPriceDecreaseLimit: 15,
      decreaseSalesCount: 5.0,
      // randomPennies: false,
      // manualPennies: 99,
      countAtMaxPurchasePrice: true,
      useAllProductBatchNumbers: false,
      countPriceBySkuWithoutBatches: false,
      countByAvgPurchasePrice: false,
      calcPurchasePriceByClusters: false,
      useEmptyRemains: false,
      useArrivalDate: false,
      backBasketPart: 80.0,
      checkMarginDeclineProfit: false,
      declineProfitabilityPc: 25.0,
      searchPreviousPricesDepth: 7,
      compensateLowerTargets: false,
      purchasePriceSuppliers: false,
      purchasePriceSuppliersWithRemains: false,
      categoryOfSuppliers: categoryOfSuppliersSb.ALL_SUPPLIERS,
      purchasePriceSuppliersMinProfit: 5,
      purchasePriceSuppliersMinProfitForKVI: 0,
      purchasePriceSuppliersMinProfitForCompetitors: 0,
      spreadByPriceSegments: true,
    };
  }

  saleStatusOptions: Array<SelectBox<string>> = [
    {
      value: 'ACTIVE',
      label: i18n.t('selectOptions.saleStatuses.active') as string,
    },
    {
      value: 'STOPPED',
      label: i18n.t('selectOptions.saleStatuses.stopped') as string,
    },
    {
      value: 'PLANNED',
      label: i18n.t('selectOptions.saleStatuses.planned') as string,
    },
  ];

  moduleItemStatusOptions: Record<TModuleType, Array<SelectBox<string>>> = {
    sales: [
      {
        value: 'ACTIVE',
        label: i18n.t('selectOptions.saleStatuses.active') as string,
      },
      {
        value: 'STOPPED',
        label: i18n.t('selectOptions.saleStatuses.stopped') as string,
      },
      {
        value: 'PLANNED',
        label: i18n.t('selectOptions.saleStatuses.planned') as string,
      },
    ],
    promo: [
      {
        value: 'ACTIVE',
        label: i18n.t('selectOptions.saleStatuses.active') as string,
      },
      {
        value: 'STOPPED',
        label: i18n.t('selectOptions.saleStatuses.stopped') as string,
      },
      {
        value: 'PLANNED',
        label: i18n.t('selectOptions.saleStatuses.planned') as string,
      },
    ],
  };

  saleTypeOptions: Array<SelectBox<string>> = [
    {
      value: 'SALE',
      label: i18n.t('selectOptions.saleTypes.sale') as string,
    },
    {
      value: 'FLASH_SALE',
      label: i18n.t('selectOptions.saleTypes.flashSale') as string,
    },
    {
      value: 'MARKDOWN',
      label: i18n.t('selectOptions.saleTypes.markdown') as string,
    },
    {
      value: 'DISCONTINUED',
      label: i18n.t('selectOptions.saleTypes.discontinued') as string,
    },
    {
      value: 'SEASONAL',
      label: i18n.t('selectOptions.saleTypes.seasonal') as string,
    },
  ];

  moduleItemTypeOptions: Record<TModuleType, Array<SelectBox<string>>> = {
    sales: [
      {
        value: 'SALE',
        label: i18n.t('selectOptions.saleTypes.sale') as string,
      },
      {
        value: 'FLASH_SALE',
        label: i18n.t('selectOptions.saleTypes.flashSale') as string,
      },
      {
        value: 'MARKDOWN',
        label: i18n.t('selectOptions.saleTypes.markdown') as string,
      },
      {
        value: 'DISCONTINUED',
        label: i18n.t('selectOptions.saleTypes.discontinued') as string,
      },
      {
        value: 'SEASONAL',
        label: i18n.t('selectOptions.saleTypes.seasonal') as string,
      },
    ],
    promo: [
      {
        value: 'PRICE',
        label: i18n.t('selectOptions.promoTypes.priceAdj') as string,
      },
      {
        value: 'DISCOUNT',
        label: i18n.t('selectOptions.promoTypes.discount') as string,
      },
    ],
  };

  getGlobalSettingsDefaultData(): GlobalSettingsData {
    return  {
      useSalePointsDirectory: false,
      useAssortmentDirectory: false,
      usePurchasePriceFromAssortmentDirectory: false,
      useStatusFromAssortmentDirectory: false,
      useCompetitorsDirectory: false,
      useProductLineDirectory: false,
      selectKviSearchMethod: KviSearchMethod.CLUSTERIZATION,
      approvalPeriod: null,
      isRTNDocumentEnabled: false,
      sendRevaluationOnlyForChangedPrices: true,
      useSaleStatus: false,
      useTwoStepRevaluationApproval: false,
      excludeZeroRemains: false,
      revaluationStartDateOffsetDays: null
    }
  }

  getTradingSettingsDefaultData(): TradingSettingsData {
    return  {
      operatingExpenses: 0,
      revaluationExportFileFormat: RevaluationExportFileFormat.SP_CSV,
      defaultTimezone: null
    }
  }
}

export type ErrorsMap = {
  [x in string]: FieldErrorsMap
};

type FieldErrorsMap = {
  [x in string]: IError
}
